import React, { Component } from "react";
import {
 MDBBtn,
 MDBModalBody,
 MDBModalHeader,
 MDBModalFooter,
 MDBRow,
 MDBCol,
 MDBIcon,
 MDBModal,
 toast,
 MDBTabPane,
 MDBTabContent,
 MDBNav,
 MDBNavItem,
 MDBNavLink,
 MDBInput,
 MDBSpinner,
 MDBTooltip,
} from "mdbreact";
import axios from "../../../../axios";
import {
 CountryDropdown,
 RegionDropdown,
} from "vault-react-country-region-selector";
import { withTranslation } from "react-i18next";
import "react-phone-number-input/style.css";
import PhoneInput, {
 isPossiblePhoneNumber,
 isValidPhoneNumber,
} from "react-phone-number-input";
import ViewVenueServicePlans from "../../../../components/NetworkMgmt/Venues/ViewVenueServicePlans";
import ViewVenueKeypools from "../../../../components/NetworkMgmt/Venues/ViewVenueKeypools";
import ViewVenueAdministrators from "../../../../components/NetworkMgmt/Venues/ViewVenueAdministrators";
import ViewVenueEquipment from "../../../../components/NetworkMgmt/Venues/ViewVenueEquipment";
import ViewVenueUnits from "../../../../components/NetworkMgmt/Venues/ViewVenueUnits";
import ViewVenueBandwidthUsage from "../../../../components/NetworkMgmt/Venues/ViewVenueBandwidthUsage";
import ModifyUnit from "../../../../components/NetworkMgmt/Forms/ModifyUnit/ModifyUnit";
import ModifyResident from "../../../../components/VenueMgmt/Forms/ModifyResident/ModifyResident";
import SelectSearch, { fuzzySearch } from "react-select-search";
import TransactionsTable from "../../../../components/NetworkMgmt/Transactions/Datatables/VenueTransactionsTableMUI";
import ManageDevicesData from "../../../../components/SubscriberMgmt/ManageDevices/Datatables/ManageDevicesDataMUI";
import VenueDevicesDataMUI from "../../../../components/NetworkMgmt/Venues/Datatables/VenueDevicesDataMUI";
import ViewSuppressedDevices from "../../../../components/NetworkMgmt/Venues/ViewSuppressedDevices";
import { DateInput } from "semantic-ui-calendar-react";
import countryInfo from "country-locale-map";
import JSONPretty from "react-json-pretty";

import LogViewer from "../../../../components/NetworkMgmt/Logs/LogViewer";
class ModifyVenue extends Component {
 constructor(props) {
  super(props);
  this.state = {
   loading_prop_groups: false,
   loading_pms_profiles: false,
   venueID: this.props.venueID,
   loading: false,
   activeItem: "1",
   activeItemDevices: "1",
   loading_venue_info: false,
   loading_keypools: false,
   clearDropDown: this.props.clearDropDown,
   venueTypeOptions: [
    { value: "WIRED+WIFI", name: "Wi-Fi and Wired Access" },
    { value: "WIRED", name: "Wired Access Only" },
   ],
   enableSyncMessage: "",
   dateStart: undefined,
   dateEnd: undefined,
   trialCyclesOptions: [
    { value: -1, name: -1 },
    { value: 0, name: 0 },
    { value: 1, name: 1 },
   ],
   selectedID: this.props.selectedID,
   disabled: sessionStorage.getItem("customerSupport") > 0,
   modalValidationRequirements: false,
   validationErrors: [],
   isModifyingVenue: false,
   isInitialLoading: false,
   isLoadingVenueSelection: false,
   venueLog: undefined,
   modalViewModifyUnit: false,
   unitSubscriptionsList: undefined,
   unitInfo: undefined,
   unitSubscriptionsListID: undefined,
   modalModifyResident: false,
   subscriberData: undefined
  };
 }
 componentDidMount() {
  // console.log('🚨 ModifyVenue componentDidMount called');
  // this.setState({ isInitialLoading: true });
  // Set loading states for individual functions
  // this.setState({
  //  loading_keypools: true,
  //  loading_prop_groups: true,
  // });
  // Start all the loading operations (getVenueInfo will be called when venueInfo prop is available)
  if (sessionStorage.getItem("venueID")) {
  Promise.all([
   this.getKeyPools(),
   this.getPropertyManagementGroups(),
   this.getLogs(),
   this.getVenues(),
   this.getDevices(),
   this.fetchPMSProfiles(),
  ]).finally(() => {
   // Set loading state to false immediately when all API calls complete
   this.setState({ isInitialLoading: false });
   console.log('ModifyVenue componentDidMount: All API calls completed');
  });
} else {
  Promise.all([
  //  this.getKeyPools(),
   this.getPropertyManagementGroups(),
  //  this.getLogs(),
   this.getVenues(),
  //  this.getDevices(),
   this.fetchPMSProfiles(),
  ]).finally(() => {
   // Set loading state to false immediately when all API calls complete
   this.setState({ isInitialLoading: false });
   console.log('ModifyVenue componentDidMount: All API calls completed');
  });
 }
}
 componentDidUpdate(prevProps) {
  // Check if venueInfo becomes available for the first time (to populate form fields)
  const venueInfoBecameAvailable = !prevProps.venueInfo && this.props.venueInfo;
  // Only trigger reload when venueID actually changes (not on initial load or other prop changes)
  const venueIDChanged = prevProps.venueID !== this.props.venueID && 
                         this.props.venueID && 
                         prevProps.venueID !== undefined;
  // Check if venue refresh was triggered (for same venue re-selection)
  const venueRefreshTriggered = prevProps.venueRefreshTrigger !== this.props.venueRefreshTrigger && 
                               this.props.venueRefreshTrigger !== undefined;
  console.log('🚨 ModifyVenue componentDidUpdate debug:', {
    venueInfoBecameAvailable,
    venueIDChanged,
    venueRefreshTriggered,
    prevVenueID: prevProps.venueID,
    currentVenueID: this.props.venueID,
    prevVenueInfo: !!prevProps.venueInfo,
    currentVenueInfo: !!this.props.venueInfo,
    prevRefreshTrigger: prevProps.venueRefreshTrigger,
    currentRefreshTrigger: this.props.venueRefreshTrigger
  });
  // Populate form fields when venueInfo becomes available
  if (venueInfoBecameAvailable) {
    // console.log('componentDidUpdate: venueInfo became available, populating form fields');
    this.getVenueInfo();
  }
  if (venueIDChanged || venueRefreshTriggered) {
    const reason = venueIDChanged ? 'venue ID changed' : 'venue refresh triggered';
    console.log('componentDidUpdate detected venue change:', {
      reason,
      prevVenueID: prevProps.venueID,
      currentVenueID: this.props.venueID,
      refreshTrigger: this.props.venueRefreshTrigger
    });
    // Reload data when venue ID changes OR when refresh is triggered
    this.setState({
      isInitialLoading: true,
      venueInfo: this.props.venueInfo,
      propMgmtID: undefined,
      clearDropDown: false,
      transactions: undefined, // Clear transactions when venue changes
      dateStart: undefined, // Clear transaction search start date
      dateEnd: undefined // Clear transaction search end date
    }, () => {
      // Only after state is updated, start loading data
      Promise.all([
        this.getVenueInfo(),
        this.getKeyPools(),
        this.getPropertyManagementGroups(),
        this.getLogs(),
        this.getVenues(),
        this.getDevices(),
        this.fetchPMSProfiles()
      ]).finally(() => {
        // Set loading state to false immediately when all API calls complete
        this.setState({ isInitialLoading: false });
        console.log('ModifyVenue venue change/refresh: All API calls completed');
      });
    });
  }
  // Reset loading state when operation completes
  if (prevProps.loading !== this.props.loading && this.props.loading === false) {
    console.log('Loading state changed to false - resetting isModifyingVenue');
    this.setState({ isModifyingVenue: false });
  }
   }
 getVenueInfo = () => {
  // console.log('🚨 getVenueInfo called, venueInfo available:', !!this.props.venueInfo);
  this.setState({ loading_venue_info: true });
  if (this.props.venueInfo !== undefined) {
   this.setState({
    venueName: this.props.venueInfo["VenueName"],
    address1: this.props.venueInfo["AddressLine1"],
    address2: this.props.venueInfo["AddressLine2"],
    city: this.props.venueInfo["City"],
    state: this.props.venueInfo["State"],
    postalcode: this.props.venueInfo["PostalCode"],
    country: this.props.venueInfo["Country.ISO3166A3"],
    contactName: this.props.venueInfo["PrimaryContactName"],
    firstName: this.props.venueInfo["PrimaryContactGivenName"],
    lastName: this.props.venueInfo["PrimaryContactFamilyName"],
    // phoneNumber:
    //  this.props.venueInfo["DisplayConfiguration"]["Support"][
    //  "SupportPhoneNumber.E164"
    //  ],
    // phone: this.props.venueInfo["PrimaryContactPhoneNumber.E164"],
    // email: this.props.venueInfo[
    //  "SupportEmailAddress"
    // ],
    region: this.props.venueInfo["State"],
    value: "en",
    countdown: this.props.venueInfo?.Notifications?.["WelcomeEmail_countdown_hours"],
    selectGroup:
     this.props.venueInfo["PropertyManagementGroup"][
     "PropertyManagementGroupID"
     ],
    selectKeypool: Object.keys(this.props.venueInfo["Keypools"])[0],
    durationResident:
     this.props.venueInfo[
     "DefaultSubscriptionDurationHours_GlobalWirelessPlusLocalWiredAccess"
     ],
    durationGuest:
     this.props.venueInfo[
     "DefaultSubscriptionDurationHours_LocalWirelessAccess"
     ],
    durationRoaming:
     this.props.venueInfo[
     "DefaultSubscriptionDurationHours_GlobalWirelessRoaming"
     ],
    selectDefaultServicePlanResident:
     this.props.venueInfo?.ServicePlanConfiguration?.[
     "DefaultServicePlanID_GlobalWirelessPlusLocalWiredAccess"
     ],
    selectDefaultServicePlanWireless:
     this.props.venueInfo?.ServicePlanConfiguration?.[
     "DefaultServicePlanID_LocalWirelessAccess"
     ],
    selectDefaultServicePlanRoaming:
     this.props.venueInfo?.ServicePlanConfiguration?.[
     "DefaultServicePlanID_Roaming"
     ],
    nasID: this.props.venueInfo?.NetworkConfiguration?.["NAS-Identifier"],
    minVlanRes:
     this.props.venueInfo?.NetworkConfiguration?.[
     "MinimumAutoGeneratedVLAN_GlobalWirelessPlusLocalWiredAccess"
     ],
    maxVlanRes:
     this.props.venueInfo?.NetworkConfiguration?.[
     "MaximumAutoGeneratedVLAN_GlobalWirelessPlusLocalWiredAccess"
     ],
    minVlanGuest:
     this.props.venueInfo?.NetworkConfiguration?.[
     "MinimumAutoGeneratedVLAN_LocalWirelessAccess"
     ],
    maxVlanGuest:
     this.props.venueInfo?.NetworkConfiguration?.[
     "MaximumAutoGeneratedVLAN_LocalWirelessAccess"
     ],
    minVlanRoaming:
     this.props.venueInfo?.NetworkConfiguration?.[
     "MinimumAutoGeneratedVLAN_GlobalWirelessRoaming"
     ],
    maxVlanRoaming:
     this.props.venueInfo?.NetworkConfiguration?.[
     "MaximumAutoGeneratedVLAN_GlobalWirelessRoaming"
     ],
    // selectedVenueType: this.props.venueInfo["VenueType"],
    shoppingCartPriceAdjustment:
     this.props.venueInfo["ShoppingCart"]
     ["ShoppingCartPriceAdjustment"] / 100,
     // PMS Configuration Fields
     PMSProfileModified: false, // Reset flag when loading venue info
     PMSEnableUnitSync: this.props.venueInfo["PMS"]?.["enableUnitSync"] ?? false,
     PMSEnableSubscriberSync: this.props.venueInfo["PMS"]?.["enableSubscriberSync"] ?? false,
     PMSRealPageSiteId: this.props.venueInfo["PMS"]?.["RealPage"]?.["SiteId"] || "",
     PMSEntrataPropertyId: this.props.venueInfo["PMS"]?.["Entrata"]?.["PropertyID"] || "",
     PMSSyncDate: (() => {
       const syncDate = this.props.venueInfo["PMS"]?.["SyncDateTimeUTC"];
       if (syncDate && syncDate !== "") {
         try {
           return Intl.DateTimeFormat("en-US", {
             year: "numeric",
             month: "numeric",
             day: "numeric",
             hour: "numeric",
             minute: "numeric",
           }).format(new Date(syncDate));
         } catch (error) {
           console.warn("Invalid date format for SyncDateTimeUTC:", syncDate);
           return "";
         }
       }
       return "";
     })(),
     PMSLastSyncDate: (() => {
       const syncDate = this.props.venueInfo["PMS"]?.["LastSyncDateTimeUTC"];
       if (syncDate && syncDate !== "") {
         try {
           return Intl.DateTimeFormat("en-US", {
             year: "numeric",
             month: "numeric",
             day: "numeric",
             hour: "numeric",
             minute: "numeric",
           }).format(new Date(syncDate));
         } catch (error) {
           console.warn("Invalid date format for LastSyncDateTimeUTC:", syncDate);
           return "";
         }
       }
       return "";
     })(),
     PMSLastSyncSuccess: this.props.venueInfo["PMS"]?.["LastSyncSuccess"] !== undefined ? this.props.venueInfo["PMS"]["LastSyncSuccess"] : null,
     PMSLastSyncMessage: this.props.venueInfo["PMS"]?.["LastSyncMessage"] !== undefined ? this.props.venueInfo["PMS"]["LastSyncMessage"] : '',
     PMSSyncInProgress: this.props.venueInfo["PMS"]?.["SyncInProgress"],
     PMSSyncedUnits: this.props.venueInfo["PMS"]?.["SyncedUnits"] ? this.props.venueInfo["PMS"]["SyncedUnits"] : 0,
     PMSSyncedSubscribers: this.props.venueInfo["PMS"]?.["SyncedSubscribers"] ? this.props.venueInfo["PMS"]["SyncedSubscribers"] : 0,
    isVenuePMSConfigured: !!(this.props.venueInfo["PMS"] && this.props.venueInfo["PMS"]["ProfileID"]),
    loading_venue_info: false,
    enableShoppingCart:
     this.props.venueInfo["ShoppingCart"]["enableShoppingCart"],
    sendSubscriptionAddedEmail:
     this.props.venueInfo?.Notifications?.["sendSubscriptionAddedEmail"],
    sendSubscriptionEndEmail:
     this.props.venueInfo?.Notifications?.["sendSubscriptionEndEmail"],
    allowOverlapping:
     this.props.venueInfo?.NetworkConfiguration?.[
     "allowOverlappingSubscriptionWiredUnit"
     ],
    selectedTrialCycles:
     this.props.venueInfo["ShoppingCart"]["Stripe"][
     "TrialCycleAdjustment"
     ],
    selectedID: this.props.venueInfo["VenueID"],
    dateAdded: this.props.venueInfo["dateAddedUTC.ISO8601"],
    externalVenueID: this.props.venueInfo["externalVenueID"],
    stripePublishableKey:
     this.props.venueInfo["ShoppingCart"]["Stripe"][
     "StripePublishableKey"
     ],
    stripeSecretKey:
     this.props.venueInfo["ShoppingCart"]["Stripe"]["Stripe_Secret_key"],
    stripeWebhookSigningSecret:
     this.props.venueInfo["ShoppingCart"]["Stripe"][
     "Stripe_Webhook_signingsecret"
     ],
    displayFCCLabel:
     this.props.venueInfo["FCCLabel"]["displayLabel"],
    typicalLatency:
     this.props.venueInfo["FCCLabel"]["TypicalLatency"] === -1
      ? ""
      : this.props.venueInfo["FCCLabel"]["TypicalLatency"],
    displayOptionIDGlobal: this.props.displayOptionIDGlobal,
    displayOptionID: this.props.venueInfo["DisplayOptionID"],
    venueUnits: this.props.venueInfo["Units-Building-Floor-List-Subscribers"] || [],
   });
   let optionTemplateServicePlans = [];
   Object.keys(this.props.venueInfo["AvailableServicePlans"]).map(
    (value, i) => {
     optionTemplateServicePlans.push({
      value: this.props.venueInfo["AvailableServicePlans"][
       value
      ]["ServicePlanID"],
      name: this.props.venueInfo["AvailableServicePlans"][
       value
      ]["ServicePlanName"],
     });
     return true;
    }
   );
   setTimeout(
    () => {
      this.syncPMSProfileSelection();
      this.setState({
       optionTemplateServicePlans: optionTemplateServicePlans,
       loading: false,
      });
    },
    1
   );
  }
  // Return a resolved promise since this function is synchronous
  return Promise.resolve();
 };
 validateEmail = (email) => {
  const mailformat = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
  this.setState({
   invalidPhone: undefined,
   userFound: false,
   userFoundWithPhone: false,
  });
  if (!this.state.email?.match(mailformat)) {
   this.setState({
    invalidEmail: "Please provide a valid email address",
   });
  } else {
   this.setState({ invalidEmail: undefined });
  }
 };
 handleSelectGroup = (value) => {
  this.setState({ selectGroup: value });
 };
 handleSelectVenueType = (value) => {
  this.setState({ selectedVenueType: value });
 };
 handleSelectTrialCycles = (value) => {
  this.setState({ selectedTrialCycles: value });
 };
 modifyVenueInfo = (event) => {
  event.preventDefault();
  event.target.className += " was-validated";
  // First run validation check
  const isValid = this.checkValidationRequirements();
  // If validation fails, the modal will be shown by checkValidationRequirements
  if (!isValid) {
   return;
  }
  if (
   this.state.venueName !== undefined &&
   this.state.address1 !== undefined &&
   this.state.country !== undefined &&
   this.state.city !== undefined &&
   this.state.region !== undefined &&
   this.state.postalcode !== undefined
  ) {
   // Set loading state to show modification in progress
   this.setState({ isModifyingVenue: true });
   this.props.modifyVenueInfo(
    this.state.address1,
    this.state.address2 || " ",
    this.state.phoneNumber,
    this.state.country,
    this.state.city,
    this.state.region,
    this.state.postalcode,
    this.state.email,
    this.state.countdown,
    this.state.durationResident,
    this.state.durationGuest,
    this.state.durationRoaming,
    this.state.firstName,
    this.state.lastName,
    this.state.minVlanRes,
    this.state.maxVlanRes,
    this.state.minVlanGuest,
    this.state.maxVlanGuest,
    this.state.minVlanRoaming,
    this.state.maxVlanRoaming,
    this.state.selectedVenueType,
    this.state.shoppingCartPriceAdjustment,
    this.state.enableShoppingCart,
    this.state.sendSubscriptionAddedEmail,
    this.state.sendSubscriptionEndEmail,
    this.state.allowOverlapping,
    this.state.selectedTrialCycles,
    this.state.stripePublishableKey,
    this.state.stripeSecretKey,
    this.state.stripeWebhookSigningSecret,
    this.state.venueName,
    this.state.displayFCCLabel,
    this.state.typicalLatency,
    this.state.displayOptionID,
    this.state.externalVenueID,
    this.state.selectedPMSProfile,
    this.state.PMSEnableUnitSync,
    this.state.PMSEnableSubscriberSync,
    this.state.PMSRealPageSiteId,
    this.state.PMSEntrataPropertyId
   );
  }
 };
 changeHandler = (event) => {
  const { name, value } = event.target;
  const updateObject = { [name]: value };
  
  // Set PMSProfileModified to true when PMS configuration fields change
  if (name === 'PMSRealPageSiteId' || name === 'PMSEntrataPropertyId') {
   updateObject.PMSProfileModified = true;
   
   // Clear validation errors for this field when user starts typing
   if (this.state.validationErrors && this.state.validationErrors.length > 0) {
    const fieldName = name === 'PMSRealPageSiteId' ? 'RealPage Site ID' : 'Entrata Property ID';
    const filteredErrors = this.state.validationErrors.filter(e => !e.includes(fieldName));
    updateObject.validationErrors = filteredErrors;
   }
  }
  
  this.setState(updateObject);
 };
 changeHandlerPhone = (event) => {
  this.setState({ phoneNumber: event });
  const value = event
   ? isPossiblePhoneNumber(event)
    ? undefined
    : "Please provide a valid phone number"
   : "Phone number required";
  this.setState({ invalidPhone: value });
 };
 toggleCheckboxValueEnable = () => {
  this.setState({
   PMSEnableSync: !this.state.PMSEnableSync,
   enableSyncMessage:
    "Note: Enabling this setting (1) transfers subscribers with known email address to realpage enabled units. (2) Deletes empty units that were added directly to VAULT - you may be billed for non-empty units that were added directly to VAULT.",
  });
 };
 toggleCheckboxValueEnableShoppingCart = () => {
  this.setState({
   enableShoppingCart: !this.state.enableShoppingCart,
  });
 };
 toggleCheckboxValuesendSubscriptionAddedEmail = () => {
  this.setState({
   sendSubscriptionAddedEmail: !this.state.sendSubscriptionAddedEmail,
  });
 };
 toggleCheckboxValuesendSubscriptionEndedEmail = () => {
  this.setState({
   sendSubscriptionEndEmail: !this.state.sendSubscriptionEndEmail,
  });
 };
 toggleCheckboxValueAllowOverlapping = () => {
  this.setState({ allowOverlapping: !this.state.allowOverlapping });
 };
 toggleCheckboxValueDisplayFCCLabel = () => {
  this.setState({
   displayFCCLabel: !this.state.displayFCCLabel,
  });
 };
 createMask = () => {
  this.setState({
   phoneNumber: this.state.phoneNumber.replace(/\D/g, ""),
  });
 };
 cancelPMSChanges = () => {
  // Reload venue info to reset form to initial state
  this.getVenueInfo();
  // Toast notification
  toast.success("Changes cancelled. Form reset to original values.", {
   closeButton: false,
  });
 };
 handleChange = (event, { name, value }) => {
  if (this.state.hasOwnProperty(name)) {
   // Enhanced date validation for MM/DD/YYYY format
   if (name === 'dateStart' || name === 'dateEnd') {
    // Allow empty values for clearing
    if (!value || value === '') {
   this.setState({ [name]: value });
     return;
    }
    // Validate MM/DD/YYYY format with regex
    const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    // Only allow valid MM/DD/YYYY format
    if (dateRegex.test(value)) {
     // Additional validation: check if it's a valid date
     const [month, day, year] = value.split('/').map(Number);
     const date = new Date(year, month - 1, day);
     // Verify the date components match (handles invalid dates like 02/30/2024)
     if (date.getFullYear() === year && 
         date.getMonth() === month - 1 && 
         date.getDate() === day) {
      this.setState({ [name]: value });
     }
     // If invalid date components, don't update state
    }
    // If format doesn't match MM/DD/YYYY, don't update state
   } else {
    this.setState({ [name]: value });
   }
  }
 };
 toggleConfirmDisablePlan = (key) => {
  this.setState({
   modalConfirmDisablePlan: !this.state.modalConfirmDisablePlan,
  });
 };
 submitDelete = (event) => {
  this.props.submitDelete(
   this.state.email,
   this.state.venueID,
   this.state.unitID,
   this.state.building,
   this.state.floor,
   this.state.recentResidents,
   this.state.oldDateStart
  );
 };
 toggle = () => {
  this.setState({
   modal: !this.state.modal,
   modalMessage: !this.state.modalMessage,
  });
 };
 toggleTab = (tab) => () => {
  if (this.state.activeItem !== tab) {
   this.setState({
    activeItem: tab,
   });
  }
 };
 toggleTabDevices = (tab) => () => {
  if (this.state.activeItemDevices !== tab) {
   this.setState({
    activeItemDevices: tab,
   });
  }
 };
 disablePlanConfirm = (key) => {
  this.toggleConfirmDisablePlan();
  this.setState({
   toggleConfirmDisablePlan: true,
   modal: !this.state.modal,
   servicePlanID: this.props.servicePlans[key]["ServicePlanID"],
   servicePlanName: this.props.servicePlans[key]["ServicePlanName"],
  });
 };
 disablePlan = () => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   SharedSecret: this.props.sharedSecret,
   VenueID: this.props.venueID,
   ServicePlanID: this.state.servicePlanID,
  };
  this.setState({ disable_serviceplan: true });
  axios
   .post("/networkoperatorconsole/venues/disableServicePlan", body)
   .then(
    (response) => {
     toast.success("Service Plan Disabled!", {
      closeButton: false,
     });
     this.props.getVenueDetails(this.props.venueID);
     this.toggleConfirmDisablePlan();
     this.setState({ disable_serviceplan: false });
    },
    (error) => {
     toast.error("There was an error", {
      closeButton: false,
     });
     this.toggleConfirmDisablePlan();
     this.setState({ disable_serviceplan: false });
    }
   );
 };
 getPropertyManagementGroups = async () => {
  // console.log('🚨 ModifyVenue getPropertyManagementGroups called');
  this.setState({
   loading_prop_groups: true,
   groupForm: undefined,
  });
  const data = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
  };
  return axios
   .post(
    "/networkoperatorconsole/venues/listPropertyManagementGroups",
    data
   )
   .then((response) => {
    let optionTemplateGroup = [];
    Object.keys(response.data.PropertyManagementGroups).map(
     (oneKey, i) => {
      optionTemplateGroup.push({
       value: oneKey,
       name: response.data.PropertyManagementGroups[
        oneKey
       ]["PropertyManagementGroupName"],
      });
      return true;
     }
    );
    this.setState({
     optionTemplateGroup: optionTemplateGroup,
     loading_prop_groups: false,
    });
   })
   .catch((error) => {
    this.setState({ loading_prop_groups: false });
   });
 };
 getKeyPools = async () => {
  console.log('🚨 ModifyVenue getKeyPools called');
  this.setState({
   loading_keypools: true,
   keypoolForm: undefined,
  });
  const data = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
  };
  return axios
   .post("/networkoperatorconsole/keypools/listKeypools", data)
   .then((response) => {
    let optionTemplateKeyPools = [];
    Object.keys(response.data.myKeyPoolList).map((oneKey, i) => {
     optionTemplateKeyPools.push({
      value: oneKey,
      name: response.data.myKeyPoolList[oneKey]["ssid"],
     });
     return true;
    });
    this.setState({
     optionTemplateKeyPools: optionTemplateKeyPools,
     loading_prop_groups: false,
     keypoolList: response.data.myKeyPoolList,
     loading_keypools: false
    });
   })
   .catch((error) => {
    this.setState({ loading_keypools: false });
   });
 };
 getVenues = () => {
  let body = { 
    AccessToken: sessionStorage.getItem("AccessToken"),
    IdToken: sessionStorage.getItem("IdToken")
  };
  return axios
   .post("/networkoperatorconsole/venues/listVenues", body)
   .then((response) => {
    let optionTemplateVenues = [];
    optionTemplateVenues.push({
     value: "",
     name: "Please Select...",
    });
    Object.keys(response.data.VenueList).map((oneKey, i) => {
     optionTemplateVenues.push({
      value: oneKey,
      name: response.data.VenueList[oneKey]["VenueName"],
     });
     return true;
    });
    this.setState({
     optionTemplateVenues: optionTemplateVenues,
     loading_prop_groups: false,
    });
   })
   .catch((error) => {
    this.setState({ error: true });
   });
 };
 handleSelectVenue = async (value, name) => {
  // If "Select..." (empty value) is chosen, clear all fields and skip API calls
  if (!value) {
   sessionStorage.removeItem("venueID");
   sessionStorage.removeItem("venueName");
   this.setState({
    selectVenue: "",
    selectedID: undefined,
    clearDropDown: true,
    isLoadingVenueSelection: false,
    venueName: "",
    address1: "",
    address2: "",
    city: "",
    region: "",
    postalcode: "",
    country: "",
    nasID: "",
    externalVenueID: "",
    countdown: "",
    minVlanRes: "",
    maxVlanRes: "",
    minVlanGuest: "",
    maxVlanGuest: "",
    minVlanRoaming: "",
    maxVlanRoaming: "",
    allowOverlapping: false,
    sendSubscriptionAddedEmail: false,
    sendSubscriptionEndEmail: false,
    displayFCCLabel: false,
    enableShoppingCart: false,
    shoppingCartPriceAdjustment: 0,
    selectedTrialCycles: 0,
    selectedVenueType: "",
    selectGroup: "",
    displayOptionID: "",
    venueLog: undefined,
    devices: undefined,
    transactions: undefined,
    selectedPMSProfile: " ",
   });
   return;
  }
  // If the same venue is already selected, do nothing
  if (value === this.state.selectedID) {
   return;
  }
  console.log('handleSelectVenue called - setting loading to true');
  this.setState({
   selectVenue: value,
   selectedID: value,
   clearDropDown: false,
   isLoadingVenueSelection: true,
  }, () => {
   console.log('isLoadingVenueSelection set to:', this.state.isLoadingVenueSelection);
  });
  try {
   // Update the venue name and ID - this already calls getVenueDetails internally
   // The parent component will handle the loadingVenueDetails state
   await this.props.updateName(name.name, name.value);
   console.log('updateName completed');
   // Also call the other API methods directly to ensure all data is loaded
   // This is especially important when coming from "View All Venues"
   console.log('🔄 handleSelectVenue: Loading additional venue data...');
   await Promise.all([
    this.getKeyPools(),
    this.getLogs(), 
    this.getDevices(),
    this.getPropertyManagementGroups(),
    this.fetchPMSProfiles()
   ]);
   console.log('✅ handleSelectVenue: All API calls completed');
  } catch (error) {
   console.error('Error loading venue details:', error);
  } finally {
   // Clear local loading state immediately
   console.log('Setting isLoadingVenueSelection to false');
   this.setState({isLoadingVenueSelection: false});
  }
 };
 getLogs = async () => {
  console.log('🚨 ModifyVenue getLogs called for venueID:', sessionStorage.getItem("venueID"));
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: sessionStorage.getItem("venueID"),
  };
  return axios
   .post("/networkoperatorconsole/venues/listVenueLog", body)
   .then((response) => {
    this.setState({
     venueLog: response.data.log,
    });
   })
   .catch((error) => {
    this.setState({ error: true });
   });
 };
 changeHandlerUnitSync = () => {
  // Only allow toggling if subscriber sync is not enabled
  if (!this.state.PMSEnableSubscriberSync) {
   this.setState({
    PMSEnableUnitSync: !this.state.PMSEnableUnitSync,
    PMSProfileModified: true,
   });
  }
 };

 changeHandlerSubscriberSync = () => {
  const newSubscriberSyncValue = !this.state.PMSEnableSubscriberSync;
  this.setState({
   PMSEnableSubscriberSync: newSubscriberSyncValue,
   // Auto-enable unit sync when subscriber sync is enabled
   PMSEnableUnitSync: newSubscriberSyncValue ? true : this.state.PMSEnableUnitSync,
   PMSProfileModified: true,
  });
 };

 // Synchronize PMS profile selection when both venue info and profiles are available
 syncPMSProfileSelection = () => {
  // Get PMS Profile ID from venue info if available
  const venuePMSProfileId = this.props.venueInfo?.["PMS"]?.["ProfileID"];
  
  if (venuePMSProfileId && this.state.pmsProfileOptions && this.state.pmsProfileOptions.length > 0) {
    const matchingProfile = this.state.pmsProfileOptions.find(p => p.value === venuePMSProfileId);
   
    if (matchingProfile && this.state.selectedPMSProfile !== venuePMSProfileId) {
      this.setState({
        selectedPMSProfile: venuePMSProfileId,
      });
    }
  } else {
    // No PMS profile in venue data, set to "No PMS"
    if (this.state.selectedPMSProfile !== " ") {
      this.setState({
        selectedPMSProfile: " ",
      });
    }
  }
 };
 
 handleSelectPMSProfile = (selectedPMSProfileId) => {
  console.log("handleSelectPMSProfile called with ID:", selectedPMSProfileId);
  
  // If single space is selected, it means "No PMS"
  const isUnlinking = selectedPMSProfileId === " " || selectedPMSProfileId === null;
  
  this.setState({
   selectedPMSProfile: isUnlinking ? " " : selectedPMSProfileId,
   PMSProfileModified: true, // Track that the profile has been changed
   // Clear venue-specific PMS fields and disable sync when changing profile
   PMSRealPageSiteId: " ",
   PMSEntrataPropertyId: " ",
   PMSEnableUnitSync: false,
   PMSEnableSubscriberSync: false
  });
 };


 fetchPMSProfiles = async () => {
  this.setState({
   loading_pms_profiles: true,
  });
  
  // Initialize with "No PMS" option
  const pmsProfileOptions = [{
   value: " ",
   name: "No PMS",
   Type: null,
   ProfileName: "No PMS"
  }];
  
  const data = {
   AccessToken: sessionStorage.getItem("AccessToken"),
  };
  
  return axios
   .post("/operatorconsole/config/listPMSProfiles", data)
   .then((response) => {
    if (response.data && response.data.PMSProfiles) {
     response.data.PMSProfiles.map((profile, i) => {
      pmsProfileOptions.push({
       // Dropdown properties
       value: profile.ProfileID,
       name: profile.ProfileName,
       // Original API properties (with duplicates for backward compatibility)
       ...profile,
       // Legacy mappings (duplicated)
      });
      return true;
     });
    }
    console.log("Fetched PMS Profiles:", pmsProfileOptions);
    
    this.setState({
     pmsProfileOptions: pmsProfileOptions,
     loading_pms_profiles: false,
    }, () => {
     // After PMS profiles are loaded, sync with venue data if available
     console.log("🚨 fetchPMSProfiles callback - syncing with venue data");
     this.syncPMSProfileSelection();
    });
   })
   .catch((error) => {
    console.error("Error fetching PMS profiles:", error);
    // Even on error, provide the "No PMS" option (already initialized above)
    this.setState({ 
     pmsProfileOptions: pmsProfileOptions,
     loading_pms_profiles: false 
    });
   });
 };

 findTransactions = (event) => {
  event.preventDefault();
  this.setState({ loading: true });
  if (
   this.state.dateStart !== undefined &&
   this.state.dateEnd !== undefined
  ) {
   let body = {
    AccessToken: sessionStorage.getItem("AccessToken"),
    IdToken: sessionStorage.getItem("IdToken"),
    "MinInvoiceDateTimeUTC.ISO8601": new Date(
     this.state.dateStart
    ).toISOString(),
    "MaxinvoiceDateTimeUTC.ISO8601": new Date(
     this.state.dateEnd
    ).toISOString(),
    VenueID: this.props.venueID,
   };
   axios
    .post(
     "/networkoperatorconsole/shoppingcart/listPayments",
     body
    )
    .then(
     (response) => {
      this.setState({ transactions: response.data.Payments });
      this.setState({ loading: false });
     },
     (error) => {
      this.setState({ loading: false });
     }
    );
  }
 };
 selectCountry(val) {
  this.setState({ country: val });
 }
 selectRegion(val) {
  this.setState({ region: val });
 }
 copyNASID = async () => {
  const copyText = document.getElementById("passwordHidden");
  try {
   await navigator.clipboard.writeText(copyText.textContent);
   this.setState({ copyText: "Copied" });
   toast.success("NAS Identifier copied", {
    closeButton: false,
   });
  } catch (err) {
   console.error('Failed to copy: ', err);
  }
 };
 copyVenueID = async () => {
  const copyText = document.getElementById("venueIDHidden");
  try {
   await navigator.clipboard.writeText(copyText.textContent);
   this.setState({ copyText: "Copied" });
   toast.success("Venue ID copied", {
    closeButton: false,
   });
  } catch (err) {
   console.error('Failed to copy: ', err);
  }
 };
 copyExternalVenueID = async () => {
  const copyText = document.getElementById("externalVenueIDHidden");
  try {
   await navigator.clipboard.writeText(copyText.textContent);
   this.setState({ copyText: "Copied" });
   toast.success("External Venue ID copied", {
    closeButton: false,
   });
  } catch (err) {
   console.error('Failed to copy: ', err);
  }
 };
 unlockStripeKeys = () => {
  const stripePublishableKey = document.getElementById(
   "stripePublishableKey"
  );
  const stripeSecretKey = document.getElementById("stripeSecretKey");
  const stripeWebhookSigningSecret = document.getElementById(
   "stripeWebhookSigningSecret"
  );
  const unlockStripeKeys = document.getElementById("unlockStripeKeys");
  if (stripePublishableKey) stripePublishableKey.disabled = !stripePublishableKey.disabled;
  if (stripeSecretKey) stripeSecretKey.disabled = !stripeSecretKey.disabled;
  if (stripeWebhookSigningSecret) stripeWebhookSigningSecret.disabled = !stripeWebhookSigningSecret.disabled;
  if (unlockStripeKeys) {
   if (unlockStripeKeys.className === "fa fa-lock") {
    unlockStripeKeys.className = "fa fa-unlock";
   } else {
    unlockStripeKeys.className = "fa fa-lock";
   }
  }
 };
 changeHandlerDisplayOptionID = (value) => {
  this.setState({ displayOptionID: value });
 };
 getDevices = () => {
  console.log('🚨 ModifyVenue getDevices called for venueID:', sessionStorage.getItem("venueID"));
  const body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: sessionStorage.getItem("venueID"),
  };
  return axios
   .post("/operatorconsole/subscribers/listDevices", body)
   .then((response) => {
    console.log("listDevices API Response:", response.data);
    console.log("Devices array:", response.data.Devices);
    console.log("Number of devices:", response.data.Devices ? Object.keys(response.data.Devices).length : 0);
    this.setState({
     devices: response.data.Devices,
     deviceCountOffline: response.data.DeviceCountOffline,
     deviceCountOnline: response.data.DeviceCountOnline,
    });
   })
   .catch((error) => {
    console.error("listDevices API Error:", error);
    this.setState({ error: true });
   });
 };
 toggleValidationRequirements = () => {
  this.setState({
   modalValidationRequirements: !this.state.modalValidationRequirements,
  });
 };
 checkValidationRequirements = () => {
  const errors = [];
  if (!this.state.venueName || this.state.venueName.trim() === "") {
   errors.push("Venue Name is required");
  }
  if (!this.state.address1 || this.state.address1.trim() === "") {
   errors.push("Address Line 1 is required");
  }
  if (!this.state.country) {
   errors.push("Country is required");
  }
  if (!this.state.city || this.state.city.trim() === "") {
   errors.push("City is required");
  }
  if (!this.state.region) {
   errors.push("State/Region is required");
  }
  if (!this.state.postalcode || this.state.postalcode.trim() === "") {
   errors.push("Postal Code is required");
  }
  
  // Compute selectedPMSProfileInfo for validation
  const selectedPMSProfileInfo = this.state.selectedPMSProfile && 
    this.state.selectedPMSProfile !== " " && 
    this.state.pmsProfileOptions
      ? this.state.pmsProfileOptions.find(p => p.value === this.state.selectedPMSProfile)
      : null;
  
  // PMS tab validations (only when PMS tab is active)
  if (this.state.activeItem === "10") {
   // Venue Configuration validations (only if a valid PMS profile is selected, not "No PMS")
   if (this.state.selectedPMSProfile && this.state.selectedPMSProfile !== " " && selectedPMSProfileInfo) {
    if (selectedPMSProfileInfo.Type?.toLowerCase() === 'realpage') {
     if (!this.state.PMSRealPageSiteId || (typeof this.state.PMSRealPageSiteId === 'string' && this.state.PMSRealPageSiteId.trim() === "")) {
      errors.push("RealPage Site ID is required");
     }
    } else if (selectedPMSProfileInfo.Type?.toLowerCase() === 'entrata') {
     if (!this.state.PMSEntrataPropertyId || (typeof this.state.PMSEntrataPropertyId === 'string' && this.state.PMSEntrataPropertyId.trim() === "")) {
      errors.push("Entrata Property ID is required");
     }
    }
   }
   
   // PMS Sync Options validation (only if a valid PMS profile is selected, not "No PMS")
   if (this.state.selectedPMSProfile && this.state.selectedPMSProfile !== " ") {
    // Both sync options should be defined as boolean values
    if (this.state.PMSEnableUnitSync === undefined || this.state.PMSEnableUnitSync === null ||
        this.state.PMSEnableSubscriberSync === undefined || this.state.PMSEnableSubscriberSync === null) {
     errors.push("PMS Sync configuration is invalid");
    }
   }
  }
  
  this.setState({ validationErrors: errors });
  if (errors.length > 0) {
   this.setState({ modalValidationRequirements: true });
   return false;
  }
  return true;
 };
 handleSubscriberClick = (subscriberToken, email) => {
  // Fetch subscriber details and open Modify Resident modal
  this.getSubscriberDetails(subscriberToken);
 };
 toggleModifyResident = () => {
  this.setState({
   modalModifyResident: !this.state.modalModifyResident,
  });
 };
 getSubscriberDetails = (subscriberToken) => {
  // Find the subscription in venueInfo
  let subscriptionData = null;
  if (this.props.venueInfo && this.props.venueInfo["Subscriptions"]) {
   Object.keys(this.props.venueInfo["Subscriptions"]).forEach((key) => {
    const subscription = this.props.venueInfo["Subscriptions"][key];
    if (subscription["SubscriberToken"] === subscriberToken) {
     subscriptionData = subscription;
    }
   });
  }
  if (subscriptionData) {
   this.setState({
    SubscriberGivenName: subscriptionData.SubscriberGivenName,
    SubscriberFamilyName: subscriptionData.SubscriberFamilyName,
    SubscriberEmail: subscriptionData.SubscriberEmail,
    SubscriberPhoneNumber: subscriptionData["SubscriberPhoneNumber.E164"]?.toString(),
    contactpref_email: subscriptionData.contactpref_email,
    contactpref_sms: subscriptionData.contactpref_sms,
    SubscriberLocale: subscriptionData.SubscriberLocale,
    UnitFloor: subscriptionData.UnitFloor,
    UnitBuilding: subscriptionData.UnitBuilding,
    StartDateTime: subscriptionData["StartDateTimeUTC.ISO8601"],
    EndDateTime: subscriptionData["EndDateTimeUTC.ISO8601"],
    UnitID: subscriptionData.UnitID,
    ssid: subscriptionData.ssid,
    unitID_internal: subscriptionData.UnitID_internal,
    servicePlanID: subscriptionData.ServicePlan?.["ServicePlanID"],
    servicePlan: subscriptionData.ServicePlan?.["ServicePlanName"],
    vlan: subscriptionData.vlan,
    status: subscriptionData.Status,
    PMS: subscriptionData["PMS"],
    PMSSyncDate: subscriptionData["PMS.SyncDateTimeUTC"],
    subscriberManagedviaSSO: subscriptionData["SubscriberManagedviaSSO"],
    StripeClientSecret: subscriptionData["StripeClientSecret"],
    paymentFailed: subscriptionData["paymentFailed"],
    subscriberToken: subscriptionData.SubscriberToken,
    RealPageUnitID: subscriptionData.RealPageUnitID,
    country: subscriptionData["Country.ISO3166A3"],
    subscriptionDiscount: subscriptionData["VenueUnitShoppingCartPriceAdjustment"] / 100,
    venueDiscount: subscriptionData["VenuePriceAdjustment"] / 100,
    externalSubscriberID: subscriptionData["externalSubscriberID"],
    selectedServicePlanPrice: subscriptionData["ListBillingCyclePrice"],
    stripeClientParentSecret: subscriptionData["StripeClientSecret"],
    setupIntentID: subscriptionData["SetupIntentId"],
   }, () => {
    this.toggleModifyResident();
   });
  }
 };
 toggleViewModifyUnit = () => {
  this.setState({
   modalViewModifyUnit: !this.state.modalViewModifyUnit,
  });
 };
 getSubscriptionListForUnit = (unitIDInternal) => {
  // Find the unit in unitsArrayAll
  let unitData = null;
  if (this.props.unitsArrayAll) {
   Object.keys(this.props.unitsArrayAll).forEach((key) => {
    const unit = this.props.unitsArrayAll[key];
    // Try different possible property names
    const unitIdInternal = unit["UnitID_internal"] || unit["unitID_internal"] || unit["UnitIDInternal"];
    // Try both strict and loose comparison
    if (unitIdInternal === unitIDInternal || String(unitIdInternal) === String(unitIDInternal)) {
     unitData = unit;
    }
   });
  }
  if (unitData) {
   let subscriptionList = [];
   subscriptionList.push(unitData["subscriptions"] || {});
   this.setState({
    unitSubscriptionsList: subscriptionList,
    unitInfo: unitData,
    unitSubscriptionsListID: Object.keys(unitData["subscriptions"] || {}),
   }, () => {
    this.toggleViewModifyUnit();
   });
  }
 };
 handleUnitClick = (unitIDInternal, unitID) => {
  // Open the Modify Unit modal
  this.getSubscriptionListForUnit(unitIDInternal);
 };
 submitModifyUnitAddress = (
  venueID,
  unitID,
  building,
  floor,
  address1,
  address2,
  city,
  state,
  country,
  postalcode,
  smsCode,
  unitID_internal,
  vlan,
  shoppingCartUnitPriceAdjustment,
  allowOverlapping,
  enableShoppingCart,
  selectedServicePlan
 ) => {
  this.setState({ update_unit: true });
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   UnitID_internal: unitID_internal,
   SMSCode: smsCode,
   AddressLine1: address1,
   AddressLine2: address2 || " ",
   City: city,
   State: state,
   "Country.ISO3166A3": country,
   PostalCode: postalcode,
   vlan: vlan,
   ShoppingCartPriceAdjustment:
    -Math.abs(shoppingCartUnitPriceAdjustment) * 100,
   allowOverlappingSubscriptionWiredUnit: allowOverlapping,
   enableShoppingCart: enableShoppingCart,
   ServicePlanID: selectedServicePlan,
  };
  axios
   .post(
    "/operatorconsole/venues/configureVenueUnit",
    body,
    {
     headers: {},
    }
   )
   .then(
    (response) => {
     this.setState({ update_unit: false });
     toast.success("Unit updated successfully!");
     this.toggleViewModifyUnit();
     // Refresh venue details if needed
     if (this.props.getVenueDetails) {
      this.props.getVenueDetails(sessionStorage.getItem("venueID"));
     }
    },
    (error) => {
     this.setState({ update_unit: false });
     toast.error("Error updating unit");
    }
   );
 };
 submitModifyResident = (
  email,
  firstName,
  lastName,
  phoneNumber,
  language,
  contactpref_email,
  contactpref_sms,
  recentResidents,
  dateStart,
  oldDateStart,
  dateEnd,
  oldDateEnd,
  venueID,
  unitID,
  building,
  floor,
  servicePlanID,
  isUpdated,
  isUpdatedServicePlan,
  isUpdatedStartDate,
  isUpdatedEndDate,
  isUpdatedSubscriptionDiscount,
  unitID_internal,
  selectedServicePlanName,
  subscriberToken,
  updatedUnit,
  subscriptionDiscount,
  setupIntentID,
  guest
 ) => {
  this.setState({ loading: true });
  let bodyDateStart = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   EmailAddress: email,
   VenueID: venueID,
   UnitID_internal: unitID_internal,
   "StartDateTimeUTC.ISO8601": new Date(oldDateStart)
    .toISOString()
    .replace(/:00.\d+Z$/g, "Z"),
   "NewStartDateTimeUTC.ISO8601": new Date(dateStart)
    .toISOString()
    .replace(/:00.\d+Z$/g, "Z"),
   UserTimeZone: new Date().getTimezoneOffset(),
   SubscriberToken: subscriberToken,
  };
  let bodyDateEnd = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   EmailAddress: email,
   VenueID: venueID,
   UnitID_internal: unitID_internal,
   "StartDateTimeUTC.ISO8601": new Date(oldDateStart).toISOString(),
   "NewEndDateTimeUTC.ISO8601":
    dateEnd !== undefined
     ? new Date(dateEnd).toISOString().replace(/:00.\d+Z$/g, "Z")
     : undefined,
   UserTimeZone: new Date().getTimezoneOffset(),
   SubscriberToken: subscriberToken,
  };
  let bodyServicePlan = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   EmailAddress: email,
   VenueID: venueID,
   UnitID_internal: unitID_internal,
   "CurrentStartDateTimeUTC.ISO8601": new Date(oldDateStart).toISOString(),
   NewServicePlanID: servicePlanID,
   UserTimeZone: new Date().getTimezoneOffset(),
   SubscriberToken: subscriberToken,
  };
  let bodyUpdatePII = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   EmailAddress: email,
   GivenName: firstName,
   FamilyName: lastName,
   "PhoneNumber.E164": phoneNumber,
   locale: language,
   contactpref_email: true,
   contactpref_sms: contactpref_sms,
   VenueID: venueID,
   SubscriberToken: subscriberToken,
  };
  let bodyUpdateUnit = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   StripeClientSecret: sessionStorage.getItem("stripeClientSecretSubscriber"),
   SetupIntentId: setupIntentID,
   NewUnitID_internal: unitID_internal,
   VenueID: venueID,
  };
  let bodyUpdateSubscriberPrice = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   StripeClientSecret: sessionStorage.getItem("stripeClientSecretSubscriber"),
   SetupIntentId: "",
   VenueID: venueID,
   NewVenueUnitPriceAdjustment: -Math.abs(subscriptionDiscount) * 100,
   "NewEndDateTimeUTC.ISO8601":
    dateEnd !== undefined
     ? new Date(dateEnd).toISOString().replace(/:00.\d+Z$/g, "Z")
     : "",
  };
  Promise.all([
   new Date(dateStart).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) && isUpdatedStartDate === true
    ? axios.post(
       "/networkoperatorconsole/subscribers/resetSubscriptionStartDate",
       bodyDateStart,
       { headers: {} }
      )
    : Promise.resolve(),
   isUpdatedEndDate === true
    ? axios.post(
       "/networkoperatorconsole/subscribers/resetSubscriptionEndDate",
       bodyDateEnd,
       { headers: {} }
      )
    : Promise.resolve(),
   isUpdated === true
    ? axios.post(
       "/networkoperatorconsole/subscribers/updateSubscriberPII",
       bodyUpdatePII,
       { headers: {} }
      )
    : Promise.resolve(),
   isUpdatedServicePlan === true
    ? axios.post(
       "/networkoperatorconsole/subscribers/modifyServicePlan",
       bodyServicePlan,
       { headers: {} }
      )
    : Promise.resolve(),
   updatedUnit === true
    ? axios.post(
       "/networkoperatorconsole/subscribers/modifyVenueUnit",
       bodyUpdateUnit,
       { headers: {} }
      )
    : Promise.resolve(),
   isUpdatedSubscriptionDiscount === true
    ? axios.post(
       "/venuemgmtconsole/subscribers/modifySubscriptionPrice",
       bodyUpdateSubscriberPrice,
       { headers: {} }
      )
    : Promise.resolve(),
  ])
   .then(([res1, res2, res3, res4, res5, res6]) => {
    toast.success("Updated Resident!", { closeButton: false });
    this.toggleModifyResident();
    this.setState({ loading: false });
    // Refresh venue details
    if (this.props.getVenueDetails) {
     this.props.getVenueDetails(sessionStorage.getItem("venueID"));
    }
   })
   .catch((error) => {
    toast.error(error.response?.data?.message || "There was an error!", {
     closeButton: false,
    });
    this.toggleModifyResident();
    this.setState({ loading: false });
   });
 };
 deleteResident = (
  email,
  venueID,
  unitID,
  building,
  floor,
  recentResidents,
  oldDateStart,
  unitID_internal,
  cancellationReason,
  refundAmount,
  guest
 ) => {
  this.setState({ loadingDelete: true });
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   EmailAddress: email,
   VenueID: venueID,
   UnitID_internal: unitID_internal,
   endImmediately: true,
   "StartDateTimeUTC.ISO8601": new Date(oldDateStart).toISOString(),
   UserTimeZone: new Date().getTimezoneOffset(),
   CancellationReasons: cancellationReason,
   requestedRefundAmount: refundAmount,
  };
  axios
   .post(
    "/networkoperatorconsole/subscribers/resetSubscriptionEndDate",
    body,
    { headers: {} }
   )
   .then((response) => {
    toast.success("Deleted Resident!", { closeButton: false });
    this.toggleModifyResident();
    this.setState({ loadingDelete: false });
    // Refresh venue details
    if (this.props.getVenueDetails) {
     this.props.getVenueDetails(sessionStorage.getItem("venueID"));
    }
   })
   .catch((error) => {
    toast.error("There was an error!", { closeButton: false });
    this.setState({ error: true, loadingDelete: false });
   });
 };
 render() {
  // console.log(this.state);
  const { country, region } = this.state;
  const tomorrow = new Date(
   new Date().setDate(new Date().getDate() + 1)
  ).toISOString();
  const { t } = this.props;
  
  // Compute selectedPMSProfileInfo from state instead of storing it in state
  const selectedPMSProfileInfo = this.state.selectedPMSProfile && 
    this.state.selectedPMSProfile !== " " && 
    this.state.pmsProfileOptions
      ? this.state.pmsProfileOptions.find(p => p.value === this.state.selectedPMSProfile)
      : null;
  
  // Debug logging for modal visibility
  // console.log('ModifyVenue render - isLoadingVenueSelection:', this.state.isLoadingVenueSelection);
  return (
   <>
    {/* Loading overlay for venue modification */}
    {this.state.isModifyingVenue && (
     <div className="overlay" style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      width: '100%', 
      height: '100%', 
      backgroundColor: 'rgba(0, 0, 0, 0.5)', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      zIndex: 9999 
     }}>
      <div style={{ 
       backgroundColor: 'white', 
       padding: '20px', 
       borderRadius: '8px', 
       textAlign: 'center',
       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
       <div className="spinner-border spinner-border-lg text-primary" role="status">
        <span className="sr-only">Loading...</span>
       </div>
       <p className="mt-3 mb-0">Modifying venue...</p>
      </div>
     </div>
    )}
    {/* Fallback loading modal - direct render with high z-index */}
    {(() => {
     const loadingStates = {
      isLoadingVenueSelection: this.state.isLoadingVenueSelection,
      loadingVenueDetails: this.props.loadingVenueDetails,
      loading_venue_info: this.state.loading_venue_info,
      isInitialLoading: this.state.isInitialLoading,
      loading_keypools: this.state.loading_keypools,
      loading_prop_groups: this.state.loading_prop_groups
     };
     const isLoading = Object.values(loadingStates).some(state => state);
     if (isLoading) {
      console.log('ModifyVenue loading states:', loadingStates);
     }
     return isLoading;
    })() && (
     <div 
      id="venue-loading-fallback-modal"
      className="overlay overlayIsInitialLoading"
      style={{ 
       position: 'fixed', 
       top: 0, 
       left: 0, 
       width: '100vw', 
       height: '100vh', 
       backgroundColor: 'rgba(0, 0, 0, 0.8)', 
       display: 'flex', 
       justifyContent: 'center', 
       alignItems: 'center', 
       zIndex: 999999999,
       pointerEvents: 'auto'
      }}
     >
      <div style={{ 
       backgroundColor: 'white', 
       padding: '30px', 
       borderRadius: '12px', 
       textAlign: 'center',
       boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
       maxWidth: '400px',
       margin: '20px',
       border: "3px solid var(--primary-color, #007bff)"
      }}>
       <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
        <span className="sr-only">Loading...</span>
       </div>
       <h5 className="mb-2 text-primary" style={{ color: "var(--primary-color, #007bff)" }}>Loading venue details...</h5>
       <p className="mb-0 text-muted">Please wait while we fetch the venue information</p>
      </div>
     </div>
    )}
    {/* Initial loading overlay for component mount */}
    {/* {this.state.isInitialLoading && (
     <div className="overlay overlayIsInitialLoading" style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      width: '100%', 
      height: '100%', 
      backgroundColor: 'rgba(0, 0, 0, 0.6)', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      zIndex: 9999 
     }}>
      <div style={{ 
       backgroundColor: 'white', 
       padding: '30px', 
       borderRadius: '8px', 
       textAlign: 'center',
       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
       <div className="spinner-border spinner-border-lg text-primary" role="status">
        <span className="sr-only">Loading...</span>
       </div>
       <p className="mt-3 mb-0">Loading venue details...</p>
       <p className="mb-0 text-muted">Please wait while we fetch the data</p>
      </div>
     </div>
    )} */}
    {this.state.toggleConfirm ? (
     <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
      <MDBModalHeader toggle={this.toggle}>
       Confirm Deletion
      </MDBModalHeader>
      <MDBModalBody>
       <p>
        Name:{" "}
        {this.state.firstName +
         " " +
         this.state.lastName}
       </p>
       <p>Email: {this.state.email}</p>
       <p>Unit: {this.state.unitID}</p>
       <p>Building: {this.state.building}</p>
       <p>Floor: {this.state.floor}</p>
      </MDBModalBody>
      <MDBModalFooter>
       <MDBBtn color="primary" onClick={this.submitDelete}>
        Confirm
       </MDBBtn>
       <MDBBtn color="primary" onClick={this.toggle}>
        Close
       </MDBBtn>
      </MDBModalFooter>
     </MDBModal>
    ) : null}
    <MDBModal
     isOpen={this.state.modalConfirmDisablePlan}
     toggle={this.toggleConfirmDisablePlan}
    >
     <MDBModalHeader toggle={this.toggleConfirmDisablePlan}>
      Confirm Service Plan Disable
     </MDBModalHeader>
     <MDBModalBody>
      <p>Service Plan Name: {this.state.servicePlanName}</p>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn color="primary" onClick={this.disablePlan}>
       Confirm
      </MDBBtn>
      <MDBBtn
       color="primary"
       onClick={this.toggleConfirmDisablePlan}
      >
       Close
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalValidationRequirements} toggle={this.toggleValidationRequirements} size="lg">
     <MDBModalHeader toggle={this.toggleValidationRequirements}>
      <MDBIcon icon="exclamation-triangle" className="mr-2" style={{color: '#ff6b6b'}} />
      Required Fields Missing
     </MDBModalHeader>
     <MDBModalBody>
      <p>The following fields are required before you can save changes:</p>
      <ul className="list-unstyled">
       {this.state.validationErrors.map((error, index) => (
        <li key={index} className="mb-2">
         <MDBIcon icon="times-circle" className="mr-2" style={{color: '#ff6b6b'}} />
         {error}
        </li>
       ))}
      </ul>
      <p className="mt-3 text-muted">
       Please fill in all required fields and try again.
      </p>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn color="primary" onClick={this.toggleValidationRequirements}>
       OK
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal
     isOpen={this.state.modalViewModifyUnit}
     toggle={this.toggleViewModifyUnit}
     size="fluid"
     className="form"
     centered
    >
     <ModifyUnit
      unitSubscriptionsList={this.state.unitSubscriptionsList}
      toggleViewModifyUnit={this.toggleViewModifyUnit}
      venueID={this.props.venueID}
      getVenueDetails={this.props.getVenueDetails}
      unitsList={this.props.unitsArrayAll ? Object.values(this.props.unitsArrayAll) : []}
      unitInfo={this.state.unitInfo}
      submitModifyUnitAddress={this.submitModifyUnitAddress}
      update_unit={this.state.update_unit}
      unitSubscriptionsListID={this.state.unitSubscriptionsListID}
      optionTemplateServicePlans={this.props.servicePlans}
      updateName={this.props.updateName}
      keypoolList={this.props.keyPoolList}
      allKeypools={this.state.keypoolList}
      currencyName={this.props.venueInfo?.["Currency.ISO4217"] || "USD"}
     />
    </MDBModal>
    <MDBModal
     isOpen={this.state.modalModifyResident}
     toggle={this.toggleModifyResident}
     size="fluid"
     className="form"
    >
     <ModifyResident
      toggleModifyResident={this.toggleModifyResident}
      firstName={this.state.SubscriberGivenName}
      lastName={this.state.SubscriberFamilyName}
      email={this.state.SubscriberEmail}
      phoneNumber={this.state.SubscriberPhoneNumber}
      receivetext={this.state.contactpref_email}
      receivephone={this.state.contactpref_sms}
      contactpref_sms={this.state.contactpref_sms}
      contactpref_email={this.state.contactpref_email}
      language={this.state.SubscriberLocale}
      floor={this.state.UnitFloor}
      building={this.state.UnitBuilding}
      startDate={this.state.StartDateTime}
      endDate={this.state.EndDateTime}
      unitID={this.state.UnitID}
      submitModify={this.submitModifyResident}
      venueID={this.props.venueID}
      updateName={this.props.updateName}
      loading={this.state.loading}
      SSID={this.state.ssid}
      unitID_internal={this.state.unitID_internal}
      servicePlanID={this.state.servicePlanID}
      servicePlan={this.state.servicePlan}
      submitDelete={this.deleteResident}
      availablePlans={this.props.servicePlans}
      vlan={this.state.vlan}
      status={this.state.status}
      loadingDelete={this.state.loadingDelete}
      PMS={this.state.PMS}
      PMSSyncDate={this.state.PMSSyncDate}
      subscriberManagedviaSSO={this.state.subscriberManagedviaSSO}
      StripeClientSecret={this.state.StripeClientSecret}
      paymentFailed={this.state.paymentFailed}
      subscriberToken={this.state.subscriberToken}
      RealPageUnitID={this.state.RealPageUnitID}
      country={this.state.country}
      subscriptionDiscount={this.state.subscriptionDiscount}
      venueDiscount={this.state.venueDiscount}
      externalSubscriberID={this.state.externalSubscriberID}
      selectedServicePlanPrice={this.state.selectedServicePlanPrice}
      stripeClientParentSecret={this.state.stripeClientParentSecret}
      setupIntentID={this.state.setupIntentID}
      showUpdate={this.props.showUpdate}
      cancelInputType={this.props.cancelInputType}
      keypoolList={this.props.keyPoolList}
      getVenueDetails={this.props.getVenueDetails}
     />
    </MDBModal>
    <MDBModalHeader toggle={this.props.toggleModifyVenue}>
     <h4>Venue Details</h4>
     {this.state.activeItem === "1" ? (
      <p>{t("addnewresident.required")}</p>
     ) : (
      ""
     )}
    </MDBModalHeader>
    <MDBModalBody className="venueDetails">
     <label
      htmlFor="defaultFormLoginEmailEx"
      className="black-text"
     >
      Venue Name
     </label>
     <SelectSearch
      id="selectVenue"
      search={true}
      filterOptions={fuzzySearch}
      options={this.state.optionTemplateVenues}
      isOptionSelected={true}
      inputId="venueArray"
      classNamePrefix="venue-select"
      placeholder="Select..."
      onChange={this.handleSelectVenue}
      value={
       this.state.clearDropDown === true
        ? ""
        : (this.state.selectedID || sessionStorage.getItem("venueID") || "")
      }
     />
     <MDBNav className="nav-tabs">
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "1"}
        onClick={this.toggleTab("1")}
        role="tab"
       >
        <MDBIcon icon="user" /> Profile
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "2"}
        onClick={this.toggleTab("2")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="building" /> Units
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "3"}
        onClick={this.toggleTab("3")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="chart-line" /> Bandwidth
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "4"}
        onClick={this.toggleTab("4")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="signal" /> Service Plans
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "5"}
        onClick={this.toggleTab("5")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="key" /> Keypools
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "6"}
        onClick={this.toggleTab("6")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="user-shield" /> Administrators
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "7"}
        onClick={this.toggleTab("7")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="server" /> Equipment
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "8"}
        onClick={this.toggleTab("8")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="clipboard-list" /> Logs
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "9"}
        onClick={this.toggleTab("9")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="shopping-cart" /> Shopping Cart
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "10"}
        onClick={this.toggleTab("10")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="home" /> PMS
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "11"}
        onClick={this.toggleTab("11")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="file-invoice-dollar" />{" "}
        Transactions
       </MDBNavLink>
      </MDBNavItem>
      {/* <MDBNavItem>
							<MDBNavLink
								link
								to="#"
								active={this.state.activeItem === "12"}
								onClick={this.toggleTab("12")}
								role="tab"
								disabled={this.state.selectedID === undefined ? true : false}
							>
								<MDBIcon icon="database"/> System Data
							</MDBNavLink>
						</MDBNavItem> */}
      <MDBNavItem>
       <MDBNavLink
        link
        to="#"
        active={this.state.activeItem === "13"}
        onClick={this.toggleTab("13")}
        role="tab"
        disabled={
         this.state.selectedID === undefined
          ? true
          : false
        }
       >
        <MDBIcon icon="laptop" />{" "}
        Devices
       </MDBNavLink>
      </MDBNavItem>
     </MDBNav>
     <MDBTabContent
      className="mt-1"
      activeItem={this.state.activeItem}
     >
      <MDBTabPane tabId="1" role="tabpanel">
       {
        // this.props.attributeForm.length === 0 ||
        this.state.loading_venue_info === true ||
         this.state.loading_keypools === true ||
         this.state.loading_prop_groups === true ? (
         ""
        ) : (
         <>
          <form
           className="needs-validation"
           onSubmit={this.modifyVenueInfo}
           noValidate
          >
           <h5 className="font-weight-bold pl-0 mt-1 mb-1">
            <strong>
             General Information
            </strong>
           </h5>
           <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Venue Name*
             </label>
             <input
              required
              name="venueName"
              id="venueName"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state.venueName
              }
              disabled={
               this.state.disabled
              }
             />
             <div className="invalid-feedback">
              Please provide a valid
              name
             </div>
            </MDBCol>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Property Management
              Group*
             </label>
             <SelectSearch
              id="selectGroup"
              search={true}
              filterOptions={
               fuzzySearch
              }
              options={
               this.state
                .optionTemplateGroup
              }
              isOptionSelected={true}
              inputId="groupArray"
              classNamePrefix="group-select"
              placeholder="Select..."
              onChange={
               this
                .handleSelectGroup
              }
              value={
               this.state
                .selectGroup
              }
              disabled={
               this.state.disabled
              }
             />
             <div className="invalid-feedback">
              Please provide a
              Property Management
              Group
             </div>
            </MDBCol>
            {/* <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Venue Type*
             </label>
             <MDBTooltip
              material
              placement="left"
              className="rightTooltip"
              style={{
               display: "block",
              }}
             >
              <MDBIcon
               far
               icon="question-circle"
              />
              <span>
               - Wi-Fi and Wired
               Access – Select if
               users have Wi-Fi
               access as well as
               wired access
               <br />- Wired Only
               Access – Select if
               there is no Managed
               Wi-Fi access. E.g.
               Bring your own
               Device/CPE’
              </span>
             </MDBTooltip>
             <SelectSearch
              id="selectVenueType"
              search={true}
              filterOptions={
               fuzzySearch
              }
              options={
               this.state
                .venueTypeOptions
              }
              inputId="venueTypeArray"
              classNamePrefix="unit-select form-control"
              placeholder="Select..."
              onChange={
               this
                .handleSelectVenueType
              }
              value={
               this.state
                .selectedVenueType
              }
              disabled={
               this.state.disabled
              }
             />
             <div className="invalid-feedback">
              Please provide a Venue
              Type
             </div>
            </MDBCol> */}
           </MDBRow>
           {/* <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Property Management
              Group*
             </label>
             <SelectSearch
              id="selectGroup"
              search={true}
              filterOptions={
               fuzzySearch
              }
              options={
               this.state
                .optionTemplateGroup
              }
              isOptionSelected={true}
              inputId="groupArray"
              classNamePrefix="group-select"
              placeholder="Select..."
              onChange={
               this
                .handleSelectGroup
              }
              value={
               this.state
                .selectGroup
              }
              disabled={
               this.state.disabled
              }
             />
             <div className="invalid-feedback">
              Please provide a
              Property Management
              Group
             </div>
            </MDBCol>
           </MDBRow> */}
           <MDBRow>
            <MDBCol sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Address Line 1*
             </label>
             <input
              required
              name="address1"
              id="address1"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state.address1
              }
              disabled={
               this.state.disabled
              }
             />
             <div className="invalid-feedback">
              Please provide a valid
              address
             </div>
            </MDBCol>
            <MDBCol sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Address Line 2
             </label>
             <input
              className="form-control"
              name="address2"
              id="address2"
              onChange={
               this.changeHandler
              }
              value={
               this.state.address2
              }
              disabled={
               this.state.disabled
              }
             />
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol sm="12" lg="12">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Country*
             </label>
             <div className="select-box">
              <CountryDropdown
               value={country}
               onChange={(val) =>
                this.selectCountry(
                 val
                )
               }
               priorityOptions={[
                "CAN",
                "USA",
                "GBR",
               ]}
               valueType="short"
               countryvaluetype="short"
               className="form-control"
               id="selectCountry"
               disabled
              // disabled={this.state.disabled}
              />
             </div>
             {this.state
              .invalidCountry !==
              null ? (
              <div className="invalid">
               {
                this.state
                 .invalidCountry
               }
              </div>
             ) : (
              ""
             )}
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol sm="12" lg="4">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              City*
             </label>
             <input
              // required
              name="city"
              id="city"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={this.state.city}
              disabled
             // disabled={this.state.disabled}
             />
             <div className="invalid-feedback">
              Please provide a valid
              city
             </div>
            </MDBCol>
            <MDBCol sm="12" lg="4">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              State*
             </label>
             <div className="select-box">
              <RegionDropdown
               country={country}
               value={region}
               onChange={(val) =>
                this.selectRegion(
                 val
                )
               }
               valueType="short"
               className="form-control"
               id="selectState"
               disabled
              // disabled={this.state.disabled}
              />
             </div>
             {this.state.invalidState !==
              null ? (
              <div className="invalid">
               {
                this.state
                 .invalidState
               }
              </div>
             ) : (
              ""
             )}
            </MDBCol>
            <MDBCol sm="12" lg="4">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Zip Code*
             </label>
             <input
              // required
              name="postalcode"
              id="postalcode"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state
                .postalcode
              }
              disabled
             // disabled={this.state.disabled}
             />
             <div className="invalid-feedback">
              Please provide a valid
              zipcode
             </div>
            </MDBCol>
           </MDBRow>
           <h5 className="font-weight-bold pl-0 mt-2 mb-1">
            <strong>
             Configuration Options
            </strong>
           </h5>
           <MDBRow>
            <MDBCol
             size="12"
             md="12"
             lg="6"
            >
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Welcome E-mail Send
              Advance
             </label>
             <MDBTooltip
              material
              placement="left"
              className="rightTooltip"
              style={{
               display: "block",
              }}
             >
              <MDBIcon
               far
               icon="question-circle"
              />
              <span>
               Enter the number of
               hours prior to a
               subscriber’s service
               start time that you
               want them to receive
               their welcome
               e-mail. Enter 0 if
               you want the e-mails
               to be sent as soon
               as the subscriber is
               added
              </span>
             </MDBTooltip>
             <input
              required
              name="countdown"
              id="countdown"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state.countdown
              }
              disabled={
               this.state.disabled
              }
             />
             <div className="invalid-feedback">
              Please provide a valid
              number
             </div>
            </MDBCol>
            <MDBCol
             size="12"
             md="12"
             lg="6"
            >
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Resident Devices VLAN
              Range *
             </label>
             <MDBTooltip
              material
              placement="left"
              className="rightTooltip"
              style={{
               display: "block",
              }}
             >
              <MDBIcon
               far
               icon="question-circle"
              />
              <span>
               This range will be
               used for dynamic
               VLANs if overlapping
               subscriptions is
               enabled. It will
               also be used to
               assign VLANs to
               units when adding a
               unit if you do not
               provide a VLAN when
               adding a unit.
              </span>
             </MDBTooltip>
             <MDBRow>
              <MDBCol col="6">
               <input
                required
                name="minVlanRes"
                id="minVlanRes"
                className="form-control"
                onChange={
                 this
                  .changeHandler
                }
                value={
                 this.state
                  .minVlanRes
                }
                disabled={
                 this.state
                  .disabled
                }
               />
              </MDBCol>
              <div className="invalid-feedback">
               Please provide a
               valid number
              </div>
              <MDBCol
               col="6"
               className="dash"
              >
               <input
                required
                name="maxVlanRes"
                id="maxVlanRes"
                className="form-control"
                onChange={
                 this
                  .changeHandler
                }
                value={
                 this.state
                  .maxVlanRes
                }
                disabled={
                 this.state
                  .disabled
                }
               />
              </MDBCol>
             </MDBRow>
             <div className="invalid-feedback">
              Please provide a valid
              number
             </div>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol
             size="12"
             md="12"
             lg="6"
            >
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Guest Devices VLAN Range
              *
             </label>
             <MDBTooltip
              material
              placement="left"
              className="rightTooltip"
              style={{
               display: "block",
              }}
             >
              <MDBIcon
               far
               icon="question-circle"
              />
              <span>
               Not Yet In Use: In a
               future update, this
               range will be used
               to dynamically
               assign VLANs to
               Guest devices
              </span>
             </MDBTooltip>
             <MDBRow>
              <MDBCol col="6">
               <input
                required
                name="minVlanGuest"
                id="minVlanGuest"
                className="form-control"
                onChange={
                 this
                  .changeHandler
                }
                value={
                 this.state
                  .minVlanGuest
                }
                disabled={
                 this.state
                  .disabled
                }
               />
               <div className="invalid-feedback">
                Please provide a
                valid number
               </div>
              </MDBCol>
              <MDBCol
               col="6"
               className="dash"
              >
               <input
                required
                name="maxVlanGuest"
                id="maxVlanGuest"
                className="form-control"
                onChange={
                 this
                  .changeHandler
                }
                value={
                 this.state
                  .maxVlanGuest
                }
                disabled={
                 this.state
                  .disabled
                }
               />
               <div className="invalid-feedback">
                Please provide a
                valid number
               </div>
              </MDBCol>
             </MDBRow>
            </MDBCol>
            <MDBCol
             size="12"
             md="12"
             lg="6"
            >
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Roaming Devices VLAN
              Range *
             </label>
             <MDBTooltip
              material
              placement="left"
              className="rightTooltip"
              style={{
               display: "block",
              }}
             >
              <MDBIcon
               far
               icon="question-circle"
              />
              <span>
               Not Yet In Use: In a
               future update, this
               range will be used
               to dynamically
               assign VLANs to
               roaming devices
              </span>
             </MDBTooltip>
             <MDBRow>
              <MDBCol col="6">
               <input
                required
                name="minVlanRoaming"
                id="minVlanRoaming"
                className="form-control"
                onChange={
                 this
                  .changeHandler
                }
                value={
                 this.state
                  .minVlanRoaming
                }
                disabled={
                 this.state
                  .disabled
                }
               />
               <div className="invalid-feedback">
                Please provide a
                valid number
               </div>
              </MDBCol>
              <MDBCol
               col="6"
               className="dash"
              >
               <input
                required
                name="maxVlanRoaming"
                id="maxVlanRoaming"
                className="form-control"
                onChange={
                 this
                  .changeHandler
                }
                value={
                 this.state
                  .maxVlanRoaming
                }
                disabled={
                 this.state
                  .disabled
                }
               />
               <div className="invalid-feedback">
                Please provide a
                valid number
               </div>
              </MDBCol>
             </MDBRow>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol col="6" sm="12" lg="12">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              NAS Identifier{" "}
              <MDBIcon
               icon="copy"
               onClick={
                this.copyNASID
               }
              />
             </label>
             <input
              disabled
              name="nasID"
              id="nasID"
              className="form-control"
              value={this.state.nasID}
             />
             <span id="passwordHidden">
              {this.state.nasID}
             </span>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol
             col="12"
             sm="12"
             lg="12"
            >
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Venue ID{" "}
              <MDBIcon
               icon="copy"
               onClick={
                this.copyVenueID
               }
              />
             </label>
             <input
              disabled
              id="venueID"
              name="venueID"
              className="form-control"
              value={
               this.state.selectedID || ""
              }
             />
             <span id="venueIDHidden">
              {this.state.selectedID}
             </span>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol
             col="12"
             sm="12"
             lg="12"
            >
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              External Venue ID{" "}
              <MDBIcon
               icon="copy"
               onClick={
                this
                 .copyExternalVenueID
               }
              />
             </label>
             <input
              id="externalVenueID"
              name="externalVenueID"
              className="form-control"
              value={
               this.state
                .externalVenueID
              }
              onChange={
               this.changeHandler
              }
             />
             <span id="externalVenueIDHidden">
              {
               this.state
                .externalVenueID
              }
             </span>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol
             col="12"
             sm="12"
             lg="12"
            >
             <div>
              <label
               htmlFor="defaultFormLoginSMSEx"
               className="black-text"
              >
               Display Option ID
              </label>
              <SelectSearch
               id="selectOptionID"
               search={true}
               filterOptions={
                fuzzySearch
               }
               options={
                this.props
                 .optionTemplateDisplayOptions
               }
               isOptionSelected={
                true
               }
               classNamePrefix="language-select"
               onChange={
                this
                 .changeHandlerDisplayOptionID
               }
               value={
                this.state
                 .displayOptionID ===
                 "Inherit"
                 ? this.state
                  .displayOptionIDGlobal
                 : this.state
                  .displayOptionID
               }
               placeholder="Select..."
              />
              <div className="invalid-feedback">
               Please provide a
               valid language.
              </div>
             </div>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <MDBInput
              label="Send email for added subscriptions?"
              type="checkbox"
              id="sendSubscriptionAddedEmail"
              name="sendSubscriptionAddedEmail"
              onChange={
               this
                .toggleCheckboxValuesendSubscriptionAddedEmail
              }
              checked={
               this.state
                .sendSubscriptionAddedEmail
              }
             />
             <MDBInput
              label="Send email for ended subscriptions?"
              type="checkbox"
              id="sendSubscriptionEndEmail"
              name="sendSubscriptionEndEmail"
              onChange={
               this
                .toggleCheckboxValuesendSubscriptionEndedEmail
              }
              checked={
               this.state
                .sendSubscriptionEndEmail
              }
             />
            </MDBCol>
            <MDBCol col="6" sm="12" lg="6">
             <MDBInput
              label="Allow Overlapping Subscriptions"
              type="checkbox"
              id="allowOverlapping"
              name="allowOverlapping"
              onChange={
               this
                .toggleCheckboxValueAllowOverlapping
              }
              checked={
               this.state
                .allowOverlapping
              }
             >
              <MDBTooltip
               material
               placement="left"
               className="rightTooltip"
               style={{
                display:
                 "block",
               }}
              >
               <MDBIcon
                far
                icon="question-circle"
               />
               <span>
                Allow multiple
                subscribers to
                sign up for
                service in the
                same unit. If
                enabled, a
                temporary unit
                on a dynamic
                VLAN from the
                Residential
                Devices Range
                will be created
                while the
                subscription is
                overlapping.
               </span>
              </MDBTooltip>
             </MDBInput>
             <MDBInput
              label="Enable Broadband Label?"
              type="checkbox"
              id="displayFCCLabel"
              name="displayFCCLabel"
              onChange={
               this
                .toggleCheckboxValueDisplayFCCLabel
              }
              checked={
               this.state
                .displayFCCLabel
              }
              disabled={
               this.state.disabled
              }
             >
              <MDBTooltip
               material
               placement="left"
               className="rightTooltip"
               style={{
                display:
                 "block",
               }}
              >
               <MDBIcon
                far
                icon="question-circle"
               />
               <span>
                Enabling will
                show broadband
                labels for all
                service plans at
                the venue in the
                shopping cart
                and subscriber
                account settings
               </span>
              </MDBTooltip>
             </MDBInput>
            </MDBCol>
           </MDBRow>
           <br />
           <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Typical Latency
             </label>
             <MDBTooltip
              material
              placement="left"
              className="rightTooltip"
              style={{
               display: "block",
              }}
             >
              <MDBIcon
               far
               icon="question-circle"
              />
              <span>
               The expected latency
               for subscribers.
               This field is
               required if the
               broadband label is
               enabled.
              </span>
             </MDBTooltip>
             <input
              // required
              name="typicalLatency"
              id="typicalLatency"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state
                .typicalLatency
              }
             // disabled={!this.state.displayFCCLabel}
             />
             <div className="invalid-feedback">
              Please provide a valid
              number
             </div>
            </MDBCol>
           </MDBRow>
           <br />
           <div className="text-right submitButton">
            <MDBBtn
             color="danger"
             type="submit"
             disabled={
              this.state.disabled || this.state.isModifyingVenue
             }
            >
             {this.props.loading === true || this.state.isModifyingVenue ? (
              <div
               className="spinner-border spinner-border-sm"
               role="status"
              >
               <span className="sr-only">
                Loading...
               </span>
              </div>
             ) : (
              "Save Changes"
             )}
            </MDBBtn>
           </div>
          </form>
         </>
        )
       }
      </MDBTabPane>
      <MDBTabPane tabId="2" role="tabpanel">
       <ViewVenueUnits
        venueID={this.props.venueID}
        venueName={this.state.venueName}
        sharedSecret={this.props.sharedSecret}
        updateName={this.props.updateName}
        getVenueDetails={this.props.getVenueDetails}
        unitsList={this.props.unitsArrayAll}
        unitsArrayAll={this.props.unitsArrayAll}
        availablePlans={this.props.servicePlans}
        UnitsBuildingFloorListSusbcribers={
         this.props.UnitsBuildingFloorListSusbcribers
        }
        attributeForm={this.props.attributeForm}
        loadingVenueDetails={
         this.props.loadingVenueDetails
        }
        hasUpdated={this.props.hasUpdated}
        optionTemplateVenues={
         this.state.optionTemplateVenues
        }
        handleSelectVenue={this.handleSelectVenue}
        address1={this.state.address1}
        address2={this.state.address2}
        city={this.state.city}
        state={this.state.region}
        postalcode={this.state.postalcode}
        country={this.state.country}
        optionTemplateServicePlans={
         this.state.optionTemplateServicePlans
        }
        keypoolList={this.props.keyPoolList}
        currencyName={
         this.props.currencyName
        }
        isVenuePMSConfigured={this.state.isVenuePMSConfigured}
       />
      </MDBTabPane>
      <MDBTabPane tabId="3" role="tabpanel">
       <ViewVenueBandwidthUsage
        venueID={this.props.venueID}
       />
      </MDBTabPane>
      <MDBTabPane tabId="4" role="tabpanel">
       <ViewVenueServicePlans
        venueID={this.props.venueID}
        servicePlans={this.props.servicePlans}
        disablePlanConfirm={this.disablePlanConfirm}
        venueName={this.state.venueName}
        sharedSecret={this.props.sharedSecret}
        updateName={this.props.updateName}
        getVenueDetails={this.props.getVenueDetails}
        disable_serviceplan={
         this.state.disable_serviceplan
        }
        selectDefaultServicePlanResident={
         this.state.selectDefaultServicePlanResident
        }
        selectDefaultServicePlanWireless={
         this.state.selectDefaultServicePlanWireless
        }
        selectDefaultServicePlanRoaming={
         this.state.selectDefaultServicePlanRoaming
        }
        currencyName={
         this.props.currencyName
        }
       />
      </MDBTabPane>
      <MDBTabPane tabId="5" role="tabpanel">
       <ViewVenueKeypools
        venueID={this.props.venueID}
        venueName={this.state.venueName}
        keyPoolList={this.props.keyPoolList}
        allKeypools={this.state.keypoolList}
        updateName={this.props.updateName}
        getVenueDetails={this.props.getVenueDetails}
        Units-Building-Floor-List-Subscribers={this.state.venueUnits}
       />
      </MDBTabPane>
      <MDBTabPane tabId="6" role="tabpanel">
       <ViewVenueAdministrators
        venueID={this.props.venueID}
        venueName={this.state.venueName}
        staffArrayAll={this.props.staffArrayAll}
        updateName={this.props.updateName}
        getVenueDetails={this.props.getVenueDetails}
        sharedSecret={this.props.sharedSecret}
       />
      </MDBTabPane>
      <MDBTabPane tabId="7" role="tabpanel">
       <ViewVenueEquipment
        venueID={this.props.venueID}
        venueName={this.state.venueName}
        venueEquipList={this.props.venueEquipList}
        updateName={this.props.updateName}
        getVenueDetails={this.props.getVenueDetails}
        sharedSecret={this.props.sharedSecret}
       />
      </MDBTabPane>
      <MDBTabPane tabId="8" role="tabpanel">
       <LogViewer logType="venue" venueID={this.props.venueID} />
      </MDBTabPane>
      <MDBTabPane tabId="9" role="tabpanel">
       <form
        className="needs-validation"
        onSubmit={this.modifyVenueInfo}
        noValidate
       >
        <MDBInput
         label="Enable shopping cart?"
         type="checkbox"
         id="enableShoppingCart"
         name="enableShoppingCart"
         onChange={
          this
           .toggleCheckboxValueEnableShoppingCart
         }
         checked={this.state.enableShoppingCart}
         disabled={this.state.disabled}
        >
         <MDBTooltip
          material
          placement="left"
          className="rightTooltip"
          style={{ display: "block" }}
         >
          <MDBIcon far icon="question-circle" />
          <span>
           The venue will display in your
           shopping cart for self sign up.
          </span>
         </MDBTooltip>
        </MDBInput>
        <br />
        <MDBRow>
         <MDBCol col="6" sm="12" lg="6">
          <label
           htmlFor="defaultFormLoginEmailEx"
           className="black-text"
          >
           Shopping Cart Price Discount (
           {this.props.currencyName})
          </label>
          <MDBTooltip
           material
           placement="left"
           className="rightTooltip"
           style={{ display: "block" }}
          >
           <MDBIcon
            far
            icon="question-circle"
           />
           <span>
            Apply a discount to all service
            plan billing cycle prices at
            this venue.
           </span>
          </MDBTooltip>
          <input
           type="number"
           step="0.01"
           id="shoppingCartPriceAdjustment"
           name="shoppingCartPriceAdjustment"
           className="form-control"
           onChange={this.changeHandler}
           value={
            -Math.abs(
             this.state
              .shoppingCartPriceAdjustment
            )
           }
           disabled={this.state.disabled}
          />
          <div className="invalid-feedback">
           Please provide a value.
          </div>
         </MDBCol>
        </MDBRow>
        <MDBRow>
         <MDBCol col="6" sm="12" lg="6">
          <label
           htmlFor="defaultFormLoginEmailEx"
           className="black-text"
          >
           Trial Cycles Adjustments
          </label>
          <MDBTooltip
           material
           placement="left"
           className="rightTooltip"
           style={{ display: "block" }}
          >
           <MDBIcon
            far
            icon="question-circle"
           />
           <span>
            Adjust trial cycles for all
            services plans at this venue.
           </span>
          </MDBTooltip>
          <SelectSearch
           id="selectTrialCycles"
           search={true}
           filterOptions={fuzzySearch}
           options={
            this.state.trialCyclesOptions
           }
           inputId="trialCycleArray"
           classNamePrefix="unit-select form-control"
           onChange={
            this.handleSelectTrialCycles
           }
           value={
            this.state.selectedTrialCycles
           }
           placeholder="Please select..."
           disabled={this.state.disabled}
          />
          <div className="invalid-feedback">
           Please provide a value
          </div>
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="12">
          <p>
           <label
            htmlFor="defaultFormLoginEmailEx"
            className="black-text"
           >
            Stripe Configuration Override
           </label>
           <MDBTooltip
            material
            placement="left"
            className="rightTooltip"
            style={{ display: "block" }}
           >
            <MDBIcon
             far
             icon="question-circle"
            />
            <span>
             Apply venue specific Stripe
             credentials. This will
             override Network Operator
             Stripe credentials for this
             venue. WARNING: If there are
             existing subscribers at the
             venue when changing these
             values, payments for those
             subscribers will not
             process.
            </span>
           </MDBTooltip>
           <br />
           <MDBIcon
            icon="lock"
            onClick={this.unlockStripeKeys}
            id="unlockStripeKeys"
           />{" "}
           (Click to unlock/lock)
          </p>
          <div className="borderBoxRounded">
           <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Stripe Publishable Key
             </label>
             <input
              disabled="true"
              id="stripePublishableKey"
              name="stripePublishableKey"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state
                .stripePublishableKey
              }
             />
             <div className="invalid-feedback">
              Please provide a value.
             </div>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Stripe Secret Key
             </label>
             <input
              disabled="true"
              id="stripeSecretKey"
              name="stripeSecretKey"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state
                .stripeSecretKey
              }
             />
             <div className="invalid-feedback">
              Please provide a value.
             </div>
            </MDBCol>
           </MDBRow>
           <MDBRow>
            <MDBCol col="6" sm="12" lg="6">
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="black-text"
             >
              Stripe Webhook Signing
              Secret
             </label>
             <input
              disabled="true"
              id="stripeWebhookSigningSecret"
              name="stripeWebhookSigningSecret"
              className="form-control"
              onChange={
               this.changeHandler
              }
              value={
               this.state
                .stripeWebhookSigningSecret
              }
             />
             <div className="invalid-feedback">
              Please provide a value.
             </div>
            </MDBCol>
           </MDBRow>
          </div>
         </MDBCol>
        </MDBRow>
        <div className="text-right submitButton">
         <MDBBtn
          color="danger"
          type="submit"
          disabled={this.state.disabled || this.state.isModifyingVenue}
         >
          {this.props.loading === true || this.state.isModifyingVenue ? (
           <div
            className="spinner-border spinner-border-sm"
            role="status"
           >
            <span className="sr-only">
             Loading...
            </span>
           </div>
          ) : (
           "Save Changes"
          )}
         </MDBBtn>
        </div>
       </form>
      </MDBTabPane>
      <MDBTabPane tabId="10" role="tabpanel">
       <form
        className="needs-validation"
        onSubmit={this.modifyVenueInfo}
        noValidate
       >
        
        {/* PMS Profile Selection Section */}
        <h5 className="font-weight-bold pl-0 mt-1 mb-3">
         <strong>PMS Profile Selection</strong>
        </h5>
        
        <MDBRow>
         <MDBCol col="6" sm="12" lg="6">
          <label
           htmlFor="pmsProfileSelect"
           className="black-text"
          >
           PMS Profile Configuration
          </label>
          <SelectSearch
           id="pmsProfileSelect"
           search={true}
           filterOptions={fuzzySearch}
           options={this.state.pmsProfileOptions || []}
           isOptionSelected={true}
           inputId="pmsProfileArray"
           classNamePrefix="pms-profile-select"
           placeholder="Loading PMS profiles..."
           onChange={this.handleSelectPMSProfile}
           value={this.state.selectedPMSProfile || " "}
           disabled={this.state.disabled}
          />
          {!this.state.selectedPMSProfile || this.state.selectedPMSProfile === "" || this.state.selectedPMSProfile === " " ? (
           <small className="form-text text-muted">
            No PMS integration configured. Select a profile to enable PMS sync features.
           </small>
          ) : (
           <small className="form-text text-success">
            <MDBIcon icon="check-circle" className="mr-1" />
            PMS profile selected. Configure venue-specific settings below.
           </small>
          )}
          <div className="invalid-feedback">
           Please select a valid PMS configuration option.
          </div>
         </MDBCol>
        </MDBRow>

        {/* Selected Profile Info Section */}
        {selectedPMSProfileInfo && this.state.selectedPMSProfile !== " " && (
         <>
          <br />
          <h5 className="font-weight-bold pl-0 mt-3 mb-2">
           <strong>Selected Profile Information</strong>
          </h5>
          <div className="profile-info-card p-3 mb-3">
           <MDBRow>
            <MDBCol col="6">
             <p><strong>Profile Name:</strong> {selectedPMSProfileInfo.ProfileName}</p>
             <p><strong>Type:</strong> {selectedPMSProfileInfo.Type}</p>
             <p><strong>Enable Sync:</strong> {selectedPMSProfileInfo.enableSync ? 'true' : 'false'}</p>
            </MDBCol>
            <MDBCol col="6">
             {selectedPMSProfileInfo.Type?.toLowerCase() === 'entrata' && (
              <>
               <p><strong>Domain:</strong> {selectedPMSProfileInfo.EntrataSubdomain || 'N/A'}</p>
               <p><strong>API Key:</strong> {selectedPMSProfileInfo.EntrataAPIKey || 'N/A'}</p>               
              </>
             )}
             {selectedPMSProfileInfo.Type?.toLowerCase() === 'realpage' && (
              <>
               <p><strong>URL:</strong> {selectedPMSProfileInfo.RealPageURL || 'N/A'}</p>
               <p><strong>API Key:</strong> {selectedPMSProfileInfo.RealPageAPIKey || 'N/A'}</p>
               <p><strong>PMC ID:</strong> {selectedPMSProfileInfo.RealPagePMCId || 'N/A'}</p>
              </>
             )}
            </MDBCol>
           </MDBRow>

          </div>
         </>
        )}

        {/* Venue-Specific Configuration Section */}
        {selectedPMSProfileInfo && this.state.selectedPMSProfile !== " " && (
         <>
          <br />
          <h5 className="font-weight-bold pl-0 mt-3 mb-2">
           <strong>Venue Configuration*</strong>
          </h5>
          
          <MDBRow>
           <MDBCol col="6" sm="12" lg="6">
            {selectedPMSProfileInfo.Type?.toLowerCase() === 'entrata' && (
             <>
              <label className="black-text">
               Entrata Property ID *
              </label>
              <input
               required
               type="text"
               className={`form-control ${this.state.validationErrors?.some(e => e.includes('Entrata Property ID')) ? 'is-invalid' : ''}`}
               name="PMSEntrataPropertyId"
               value={this.state.PMSEntrataPropertyId || ''}
               onChange={this.changeHandler}
               placeholder="Enter Entrata Property ID"
               disabled={this.state.disabled}
              />
              <div className="invalid-feedback">
               Please provide a valid Entrata Property ID
              </div>
              <small className="form-text text-muted">
               This ID identifies your specific property within Entrata
              </small>
             </>
            )}
            
            {selectedPMSProfileInfo.Type?.toLowerCase() === 'realpage' && (
             <>
              <label className="black-text">
               RealPage Site ID *
              </label>
              <input
               required
               type="text"
               className={`form-control ${this.state.validationErrors?.some(e => e.includes('RealPage Site ID')) ? 'is-invalid' : ''}`}
               name="PMSRealPageSiteId"
               value={this.state.PMSRealPageSiteId || ''}
               onChange={this.changeHandler}
               placeholder="Enter RealPage Site ID"
               disabled={this.state.disabled}
              />
              <div className="invalid-feedback">
               Please provide a valid RealPage Site ID
              </div>
              <small className="form-text text-muted">
               This ID identifies your specific site within RealPage
              </small>
             </>
            )}
           </MDBCol>
          </MDBRow>
         </>
        )}

        {/* PMS Sync Options Section */}
        <h5 className="font-weight-bold pl-0 mt-3 mb-2">
         <strong>PMS Sync Options</strong>
        </h5>
        
        {!this.state.selectedPMSProfile || this.state.selectedPMSProfile === "" || this.state.selectedPMSProfile === " " ? (
         <div className="alert alert-info" role="alert">
          <MDBIcon icon="info-circle" className="mr-2" />
          <strong>No PMS Profile Selected:</strong> PMS sync options are disabled. Please select a PMS profile above to configure sync settings.
         </div>
        ) : (
         <MDBRow>
          <MDBCol col="12" sm="12" lg="6">
           <MDBInput
            label="Enable Unit Sync"
            type="checkbox"
            id="enablePMSUnitSync"
            name="pmsUnitSync"
            onChange={this.changeHandlerUnitSync}
            checked={this.state.PMSEnableUnitSync}
            disabled={this.state.disabled || !this.state.selectedPMSProfile || this.state.selectedPMSProfile === " " || this.state.PMSEnableSubscriberSync}
           >
            <MDBTooltip
             material
             placement="right"
             className="rightTooltip pms-sync-tooltip"
            >
             <MDBIcon far icon="question-circle" />
             <span>
              {this.state.PMSEnableSubscriberSync 
               ? "Required for Subscriber Sync - automatically enabled and locked" 
               : "Sync unit inventory from PMS"}
             </span>
            </MDBTooltip>
           </MDBInput>
           <MDBInput
            label="Enable Subscriber Sync"
            type="checkbox"
            id="enablePMSSubscriberSync"
            name="pmsSubscriberSync"
            onChange={this.changeHandlerSubscriberSync}
            checked={this.state.PMSEnableSubscriberSync}
            disabled={this.state.disabled || !this.state.selectedPMSProfile || this.state.selectedPMSProfile === " "}
           >
            <MDBTooltip
             material
             placement="right"
             className="rightTooltip pms-sync-tooltip"
            >
             <MDBIcon far icon="question-circle" />
             <span>Sync subscribers from PMS (requires Unit Sync to be enabled)</span>
            </MDBTooltip>
           </MDBInput>
          </MDBCol>
         </MDBRow>
        )}

        <br />

        {/* Sync Status Section - Only show in view mode (when profile hasn't been changed) */}
        {!this.state.PMSProfileModified && this.state.selectedPMSProfile && this.state.selectedPMSProfile !== " " && (
         <>
          <h5 className="font-weight-bold pl-0 mt-3 mb-2">
           <strong>Last Sync</strong>
          </h5>
          <div className="sync-status-card p-3 mb-3">
           <MDBRow>
            <MDBCol col="4">
             <p><strong>Date Time:</strong> {this.state.PMSLastSyncDate || 'Never Synced'}</p>
             <p><strong>Status:</strong> 
              <span className={`ml-2 badge ${!this.state.PMSLastSyncDate ? 'badge-secondary' : this.state.PMSLastSyncSuccess === true ? 'badge-success' : 'badge-danger'}`}>
               {!this.state.PMSLastSyncDate ? 'N/A' : this.state.PMSLastSyncSuccess === true ? 'Success' : 'Failed'}
              </span>
             </p>
             {this.state.PMSLastSyncMessage && this.state.PMSLastSyncSuccess === false && (
              <p><strong>Reason:</strong> {this.state.PMSLastSyncMessage}</p>
             )}
            </MDBCol>
            <MDBCol col="4">
             <p><strong>Units Synced:</strong> {this.state.PMSSyncedUnits || '0'}</p>
             <p><strong>Subscriptions Synced:</strong> {this.state.PMSSyncedSubscribers || '0'}</p>
            </MDBCol>
           </MDBRow>
          </div>
         </>
        )}

        <div className="text-right submitButton">
         {this.state.PMSProfileModified && (
          <MDBBtn
           color="danger"
           type="button"
           onClick={this.cancelPMSChanges}
           disabled={this.state.disabled || this.state.isModifyingVenue}
           className="mr-2"
          >
           Cancel
          </MDBBtn>
         )}
         <MDBBtn
          color="danger"
          type="submit"
          disabled={this.state.disabled || this.state.isModifyingVenue}
         >
          {this.props.loading === true || this.state.isModifyingVenue ? (
           <div
            className="spinner-border spinner-border-sm"
            role="status"
           >
            <span className="sr-only">
             Loading...
            </span>
           </div>
          ) : (
           "Save Changes"
          )}
         </MDBBtn>
        </div>
       </form>
      </MDBTabPane>
      <MDBTabPane tabId="11" role="tabpanel">
       <div className="searchForm">
        <h4>Search for Transactions</h4>
        <div>
         <p style={{ color: "red" }}>
          Start and End Date are required.
         </p>
        </div>
        <form
         className="needs-validation"
         onSubmit={this.findTransactions}
        // noValidate
        >
         <MDBRow>
          <MDBCol col="6">
           <label
            htmlFor="defaultFormLoginEmailEx"
            className="black-text"
           >
            Start Date
           </label>
           <DateInput
            dateFormat="MM/DD/YYYY"
            name="dateStart"
            placeholder="MM/DD/YYYY"
            value={this.state.dateStart}
            iconPosition="left"
            onChange={this.handleChange}
            className="dateTimePicker"
            maxDate={new Date(tomorrow)}
            required
            closable
            hideMobileKeyboard
            preserveViewMode={false}
            strictParsing
           />
           <div className="invalid-feedback">
            Please provide a value.
           </div>
          </MDBCol>
          <MDBCol col="6">
           <label
            htmlFor="defaultFormLoginEmailEx"
            className="black-text"
           >
            End Date
           </label>
           <DateInput
            dateFormat="MM/DD/YYYY"
            name="dateEnd"
            placeholder="MM/DD/YYYY"
            value={this.state.dateEnd}
            iconPosition="left"
            onChange={this.handleChange}
            className="dateTimePicker"
            minDate={
             new Date(
              this.state.dateStart
             )
            }
            maxDate={new Date(tomorrow)}
            closable
            hideMobileKeyboard
            preserveViewMode={false}
            strictParsing
           />
          </MDBCol>
         </MDBRow>
         <br />
         {this.state.transactions !== undefined ? (
          <>
           {this.state.loading === true ? (
            <MDBSpinner small />
           ) : (
            <TransactionsTable
             transactions={
              this.state.transactions
             }
            />
           )}
          </>
         ) : (
          <>
           {this.state.loading === true ? (
            <MDBSpinner small />
           ) : (
            <TransactionsTable
             transactions={
              this.state.transactions
             }
            />
           )}
          </>
         )}
         <div className="text-right submitButton">
          <MDBBtn
           color="danger"
           type="submit"
           disabled={this.state.startDate === undefined && this.state.dateEnd === undefined ? true : false}
          >
           Find Transactions
          </MDBBtn>
         </div>
        </form>
       </div>
      </MDBTabPane>
      <MDBTabPane tabId="12" role="tabpanel">
       <div>
        <h4>System Data</h4>
        <MDBRow>
         <MDBCol col="12" sm="12" lg="12">
          <label
           htmlFor="defaultFormLoginEmailEx"
           className="black-text"
          >
           Venue ID
          </label>
          <input
           disabled
           id="venueID"
           name="venueID"
           className="form-control"
           value={this.state.selectedID || ""}
          />
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="12">
          <label
           htmlFor="defaultFormLoginEmailEx"
           className="black-text"
          >
           Date Added
          </label>
          <input
           disabled
           id="dateAdded"
           name="dateAdded"
           className="form-control"
           value={this.state.dateAdded}
          />
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="12">
          <label
           htmlFor="defaultFormLoginEmailEx"
           className="black-text"
          >
           External Venue ID
          </label>
          <input
           disabled
           id="nasID"
           name="nasID"
           className="form-control"
           value={this.state.externalVenueID}
          />
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="12">
          <label
           htmlFor="defaultFormLoginEmailEx"
           className="black-text"
          >
           NAS-Identifier
          </label>
          <input
           disabled
           id="nasID"
           name="nasID"
           className="form-control"
           value={this.state.nasID}
          />
         </MDBCol>
        </MDBRow>
       </div>
      </MDBTabPane>
      <MDBTabPane tabId="13" role="tabpanel">
       <MDBNav className="nav-tabs">
        <MDBNavItem>
         <MDBNavLink
          link
          to="#"
          active={this.state.activeItemDevices === "1"}
          onClick={this.toggleTabDevices("1")}
          role="tab"
         >
          Recent Devices
         </MDBNavLink>
        </MDBNavItem>
        <MDBNavItem>
         <MDBNavLink
          link
          to="#"
          active={this.state.activeItemDevices === "2"}
          onClick={this.toggleTabDevices("2")}
          role="tab"
         >
          Flagged Devices
         </MDBNavLink>
        </MDBNavItem>
       </MDBNav>
       <MDBTabContent activeItem={this.state.activeItemDevices}>
        <MDBTabPane tabId="1" role="tabpanel">
         {this.state.devices !== undefined ? (
          <>
           <VenueDevicesDataMUI 
            deviceData={this.state.devices}
            venueInfo={this.props.venueInfo}
            unitsArrayAll={this.props.unitsArrayAll}
            unitsList={this.props.unitsArrayAll ? Object.values(this.props.unitsArrayAll) : []}
            onSubscriberClick={this.handleSubscriberClick}
            onUnitClick={this.handleUnitClick}
           />
          </>
         ) : (
          <div className="spinner-border spinner-border-sm" role="status">
           <span className="sr-only">Loading...</span>
          </div>
         )}
        </MDBTabPane>
        <MDBTabPane tabId="2" role="tabpanel">
         {this.state.activeItemDevices === "2" ? (
          <ViewSuppressedDevices venueID={this.props.venueID} />
         ) : (
          ""
         )}
        </MDBTabPane>
       </MDBTabContent>
      </MDBTabPane>
     </MDBTabContent>
    </MDBModalBody>
   </>
  );
 }
}
export default withTranslation()(ModifyVenue);
